import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import { parse as parseMoney } from "vue-currency-input";
import { format as formatMoney } from "vue-currency-input";
import moment from "moment";
import { getField, updateField } from "vuex-map-fields";

import { localize as veeLocalize } from "vee-validate/dist/vee-validate.full";

import banklist from "../mfobanklist.json";
// import mortgagetypeslist from "../mortgagetypeslist.json";

Vue.use(Vuex);

const saveDataDefaultValues = {
  ubd: "",
  risks: [],
  epites: [],
  tab_id: "1",
  targya: "ingatlan_ingosag",
  baleset: [],
  fizikai: "0",
  szormek: 0,
  ekszerek: 0,
  eves_dij: 46857,
  foepulet: {
    alap_dij: 32407,
    cim_kategoria: "1",
    potdij_szorzo: [],
    teljes_osszeg: 32406400,
    ajl_min_osszeg: 41000000,
    dijtetel_szorzo: 0.7904,
    ingatlan_ajl_m2ar: 410,
  },
  risks: [],
  keszpenz: "0",
  brokerkod: "",
  brokernev: "",
  kegyeleti: "0",
  telepules: "",
  mezogazdasag: [],
  assistance: [],
  epites_eve: "",
  ertektargy: "0",
  gyujtemeny: 0,
  ingosagokA: 0,
  issue_date: "",
  kockazatok: [],
  kulterulet: "0",
  szormekdij: 0,
  vaningosag: "",
  alapterulet: "0",
  balesetdijA: "",
  ekszerekdij: 0,
  engedmenyek: [],
  lakok_szama: "0",
  merchant_id: "colo213",
  default_id: "colo213",
  sporteszkoz: [],
  storage_uid: "",
  tulajdonjog: "",
  vandalizmus: [],
  vizkarextra: [],
  zoldenergia: [],
  country_code: "",
  ertekosszdij: "",
  generatelink: "",
  iranyitoszam: "",
  mellekepulet: [],
  product_code: "",
  partnertipus: "",
  allatallomany: [],
  antik_butorok: 0,
  antiktargydij: 0,
  balesetlimitA: "",
  cim_kategoria: "",
  eves_dij_alap: 0,
  eves_dij_kieg: 0,
  eves_dij_plus: 0,
  foepulet_teto: "",
  gyakorisagdij: 0,
  gyujtemenydij: 0,
  kegyeleti_dij: "",
  keszpenz_kieg: [],
  allando_lakott: "",
  foepulet_ajl_A: 0,
  ingatlan_tipus: "",
  kepzomuveszeti: 0,
  kiemeltingosag: "0",
  mellekepuletek: "",
  termes_termeny: [],
  utasbiztositas: [],
  alapdijosszesen: 0,
  ingatlan_erteke: "",
  ingosag_alapdij: 14450,
  kegyeleti_limit: "",
  kulonleges_uveg: "0",
  zaradek_szovege: [],
  foepulet_falazat: "",
  ingosag_osszesen: 0,
  kegyeleti_tipusa: "",
  szabadban_tarolt: [],
  allatallomany_dij: "",
  allatallomany_van: "",
  berloi_felelosseg: [],
  biztositas_targya: "",
  gepek_felszereles: [],
  ingatlan_jelzalog: "0",
  ingatlanalapdij_A: 0,
  kepzomuveszetidij: 0,
  engedmeny_osszesen: 0,
  engedmeny_szazalek: 0,
  foepulet_alapdij_A: 0,
  kiemeltingosag_dij: "",
  mellekepulet_ajl_A: 0,
  nyilatkozat_szoveg:
    "a Biztosító a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás termékkel kapcsolatosan nem nyújt tanácsadást, a termék értékesítése pedig közvetlenül a biztosító online értékesítési felületén keresztül történik, az értékesítési folyamatban biztosításközvetítő nem működik közre.",
  termes_termeny_dij: "",
  termes_termeny_van: "",
  utas_biztositottak: "",
  utasbiztositas_dij: 0,
  ertektargy_osszesen: 0,
  ingatlan_ajanlott_A: 0,
  altalanos_felelosseg: "",
  eves_dij_csokkentett: 0,
  ingatlan_valaszott_A: 0,
  kiemeltingosag_limit: "",
  mellekepulet_ingosag: 0,
  mellekepuletek_descr: "",
  mellekepuletek_szama: 0,
  gepek_felszereles_dij: "",
  gepek_felszereles_van: "",
  ingosag_potdij_szorzo: 0,
  kiemeltingosag_osszeg: "",
  ingo_ingatlan_alapdijA: 0,
  ingosagok_ajanlott_arA: 0,
  ingosagok_ajanlott_arF: 0,
  ingosagok_ajanlott_arM: 0,
  kerti_veszelytelenites: [],
  mellekepulet_alapdij_A: 0,
  ingosag_dijtetel_szorzo: 1.7,
  utasbiztositottak_szama: 0,
  temetesbiztositottak_szama: 0,
  balesetbiztositas_tipusa: "",
  mellekepuletek_teljes_m2: 0,
  valasztott_ar_mellekepulet: 0,
  ajanlott_bizt_osszeg_elfogad: "",
  chosenPackage: "",
  availablePackages: {},
  packagePrices: {},
  valaszthatoKiegeszitok: {},
  chosenAccessories: {},
  packageInfo: {},
  upol: false,
  businessDiscount: 0,
  process: "NORMAL",
  stopProcess: {},
  maxDiscount: 0,
  fieldErrors: {},
};

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = "";
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
}

function removeUnusedPropertyFromSaveData(data, defaultData) {
  let filteredData = JSON.parse(JSON.stringify(data));

  for (const [key, value] of Object.entries(data)) {
    if (value === defaultData[key] || Object.keys(value).length === 0) {
      delete filteredData[key];
    }
  }
  //console.log('data filterutén');
  //console.log(filteredData);
  return filteredData;
}
function findValueByKey(obj, key) {
  // Check if the key exists in the current object
  if (key in obj) {
    return obj[key];
  }

  // Iterate through the properties of the object
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const value = obj[prop];
      if (typeof value === "object") {
        // Recursively search within nested objects
        const nestedValue = findValueByKey(value, key);
        if (nestedValue !== undefined) {
          return nestedValue;
        }
      }
    }
  }

  // Key not found
  return undefined;
}

function findAndSumNestedKey(obj, keyToFind) {
  let sum = 0;

  function findKey(obj) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (typeof obj[prop] === "object") {
          findKey(obj[prop]);
        } else if (prop === keyToFind) {
          // Check if the value is a number represented as a string
          const value = obj[prop];
          if (!isNaN(value)) {
            sum += parseFloat(value);
          }
        }
      }
    }
  }

  findKey(obj);

  return sum;
}

const getDefaultState = () => {
  return {
    fetch_uid: null,
    page: 1,
    formSubmitLoading: false,
    generalErrors: [],
    //storage_uid: localStorage.getItem('storage_uid') || null,
    //last_interaction: localStorage.getItem('last_interaction') || new Date(),
    storage_uid: null,
    last_interaction: new Date(),
    canProceedToNextPage: true,
    dm: false,
    ertekesito_koti: false,
    dm_email_sent: false,
    code: false,
    generatelink: 0,
    save_request_uid: "",
    connection: "",
    maxertekek: {},
    fetch_url: null,
    MFOLoaded: false,
    cities: [],
    product_code: "",
    partnertipus: "",
    eves_dij_plus: 0,
    kieg_emelt_eves_dij: 0,
    kieg_kedv_dij: 0,
    gyakorisag_dij_havi: 0,
    gyakorisag_szerint_fizetendo_dij: 0,
    email_valid_code: null,
    last_email: null,
    igeny_azon_href: null,
    merchant_id: "colo213",
    default_id: "colo213",
    engedmenyek: {},
    isBackButtonDisabled: false,
    fieldErrors: {},

    mainBuildingInsuranceChanged: false,
    sideBuildingInsuranceChanged: false,
    allGoodsPriceChanged: false,
    contractorPropertyZipChanged: false,
    contractorPropertyName: "Hibás irányítószám",

    marks: {},
    uzletpolitikai_max: null,
    banks: banklist,
    // mortgagetypes: mortgagetypeslist,
    mortgagetypes: {},
    generalInfo: {
      privatePerson: 1,
      contractFor: 1,
      propertyType: "tarsashaz",
      propertyInhabitated: 1,
      propertyOutskirts: 0,
      rebuild_building: 0,
      rebuild_ingosag: 0,
      propertyPhysicalJob: 0,
      propertyPhysicalJobName: "",
      propertyOwnRight: "sajat",
      propertyZip: "",
      propertyName: "",
      selectedPropertyName: null,
      contractorVat: null,
      rbnb: 0,
      rbnbPrice: 0,
    },
    insuranceProperty: {
      floorArea: "",
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: "",
      builtYear: "",
      residents: 1,
      wallType: "tegla",
      roofType: "cserep",
    },
    insuranceSideBuildings: {
      template: {
        floorArea: "",
        wallType: "tegla",
        roofType: "cserep",
      },
      list: [],
      recommendedInsurancePrice: 0,
      chosenInsurancePrice: "",
    },
    insurancePersonalGoods: {
      calculatedInsurancePrice: 0,
      acceptCalculatedInsurance: 1,
      allGoodsPrice: 0,
    },
    chooseableAccesories: {
      valuablesAbove200: false,
      valuesAbove200Minimum: 200000,
      valuesAbove200Maximum: 20000000,
      valuesAbove200Sum: 0,
      valuablesAboveInputs: {
        jewelry: 0,
        antiques: 0,
        exotic: 0,
        collection: 0,
        fineart: 0,
      },
      selectableList: {
        ertektargy: {
          selected: false,
          onlyLiving: true,
          name: "Értéktárgyak",
          insurancePrice: "Kötvény alapján",
          insuranceFee: 0,
          showable: [1, 3],
        },
        kiemeltingosag: {
          selected: false,
          onlyLiving: true,
          name: "Kiemelt ingóság",
          insurancePrice: "Kötvény alapján",
          insuranceFee: 0,
          showable: [1, 3],
        },
        keszpenz: {
          selected: false,
          onlyLiving: true,
          name: "Készpénz",
          insurancePrice: "biztosítási összeg: 200 000 Ft",
          insuranceFee: 2100,
          showable: [1, 3],
        },
        kulonleges_uveg: {
          selected: false,
          name: "Különleges üveg",
          insurancePrice: "biztosítási összeg: 300 000 Ft",
          insuranceFee: 3500,
          showable: [1],
        },
        epites: {
          selected: false,
          name: "Építés, szerelésbiztosítás",
          insurancePrice: "biztosítási összeg: 1 000 000 Ft",
          insuranceFee: 5000,
          showable: [1, 2],
        },
        epulet_hiba: {
          selected: false,
          name: "Lakóépületek rejtett hibáiból eredő károk",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        assistance: {
          selected: false,
          name: "Asszisztencia",
          insurancePrice: "biztosítási összeg: 50 000 Ft",
          insuranceFee: 4000,
          customEnding: " /3 alkalom/időszak",
          showable: [1, 2],
        },
        epulettartozek_lopas: {
          selected: false,
          name: "Épülettartozékok lopása",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        klima: {
          selected: false,
          name: "Klímaberendezés biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        szabadban_tarolt: {
          selected: false,
          name: "Szabadban tárolt vagyontárgy",
          insurancePrice: "biztosítási összeg: 300 000 Ft",
          insuranceFee: 5500,
          showable: [1, 3],
        },
        allo_noveny: {
          selected: false,
          name: "Lábon álló növényzet biztosítása",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        sporteszkoz: {
          selected: false,
          name: "Sporteszköz és sportfelszerelés",
          insurancePrice: 300000,
          insuranceFee: 5500,
          showable: [1, 3],
        },
        kisallat: {
          selected: false,
          name: "Hobbi- és kisállatbiztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        kegyeleti: {
          selected: false,
          name: "Temetés költségeinek térítése",
          insurancePrice:
            "biztosítási összeg: 150 000 Ft / 300 000 Ft / 500 000 Ft",
          insuranceFee:
            "<b>3 000 Ft</b> / <b>6 000 Ft</b> / <b>10 000 Ft</b> /év",
          showable: [1, 2, 3],
        },
        garancia: {
          selected: false,
          name: "Kiterjesztett garancia",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        okos_eszkoz: {
          selected: false,
          name: "Okos eszközök biztosítás (beleértve okos otthon eszközök)",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        berleti_dij: {
          selected: false,
          name: "Elmaradt bérleti díj biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        baleset: {
          selected: false,
          name: "Balesetbiztosítás",
          insurancePrice: "biztosítási összeg: 500 000 Ft / 1 000 000 Ft",
          insuranceFee: "<b>5 000 Ft vagy 10 000 Ft</b> /év",
          showable: [1, 2, 3],
        },
        munkanelkuliseg: {
          selected: false,
          name: "Munkanélküliségi biztosítás",
          insurancePrice: -1,
          insuranceFee: 0,
          showable: null,
        },
        felelosseg: {
          selected: false,
          name: "Felelősség biztosítás",
          insurancePrice: "biztosítási összeg: 40 000 000 Ft / 1 000 000 Ft",
          insuranceFee: "<b>5 400 Ft / 10 000 Ft</b> /év",
          showable: [1, 2, 3],
        },
        zoldenergia: {
          selected: false,
          name: "Zöld energia",
          insurancePrice:
            "biztosítási összeg: Napkollektor, napelem: 3 000 000 Ft + Hőszivattyú: 500 000 Ft",
          insuranceFee: 6000,
          showable: [1, 2],
        },
        kerti_veszelytelenites: {
          selected: false,
          name: "Kerti veszélytelenítés",
          insurancePrice: "biztosítási összeg: 200 000 Ft",
          insuranceFee: 2000,
          showable: [1, 2],
        },
        mezogazdasag: {
          selected: false,
          name: "Mezőgazdasági kiegészítés", // 3 opció, beírható összegekkel (kb mint az értéktárgyak)
          insurancePrice:
            "Kötvény alapján, kategóriánként maximum 1 000 000 Ft",
          insuranceFee: 0,
          showable: [1, 3],
        },
        vandalizmus: {
          selected: false,
          name: "Vandalizmus",
          insurancePrice: "biztosítási összeg: 300 000 Ft",
          insuranceFee: 4200,
          showable: [1, 2],
        },
        vizkarextra: {
          selected: false,
          name: "Vízkár extra (szaniter)",
          insurancePrice: "biztosítási összeg: 250 000 Ft",
          insuranceFee: 15000,
          showable: [1],
        },
        utasbiztositas: {
          selected: false,
          name: "Utasbiztosítás",
          insurancePrice:
            "biztosítási összeg: 6 000 000 Ft/esemény, / 12 000 000 Ft",
          insuranceFee: "<b>4 500 Ft</b> /fő/év",
          showable: [1, 2, 3],
        },
      },
      travelInsuranced: {
        template: {
          name: null,
          bornDate: null,
        },
        list: [],
      },
      burialInsuranced: {
        template: {
          name: null,
          bornDate: null,
        },
        list: [],
      },
      mortgage: {
        template: {
          mortgageBank: null,
          creditor: "",
          creditorLocation: "",
          mortgageId: "",
          mortgageType: "",
          mortgagePrice: 0,
          mortgageCurrency: "HUF",
          mortgageStartDate: null,
          mortgageEndDate: null,
        },
        list: [],
      },
      personTemplate: {
        name: null,
        bornDate: null,
      },
      funeralPrice: 150000,
      generalLiability: true,
      landlordLiability: false,
      farmingStock: 0,
      farmingAnimals: 0,
      farmingTools: 0,
      priorityProperty: 0,
      accidentInsuranceType: "standard",
      accessorySumPrice: 0,
    },
    paymentOptions: {
      type: "online",
      frequency: "eves",
    },
    kotes_oka: "uj_szerzodes",
    regi_kotvenyszam: "",

    electronicContact: 1,
    electronicInsuring: 1,
    ageDiscount: 1,
    couponCode: "",
    businessDiscount: 0,
    maxDiscount: 0,
    riskSettings: {
      // startDate: `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()+1}`,
      startDate: moment(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1,
        ),
      ).format("YYYY-MM-DD"),
      locationZip: "",
      locationCity: "",
      locationName: "",
      locationType: "",
      locationHouseNumber: "",
      locationBuilding: "",
      locationTopography: "",

      companyLocationZip: "",
      companyLocationCity: "",
      companyLocationName: "",
      companyLocationType: "",
      companyLocationHouseNumber: "",
      companyLocationBuilding: "",
    },
    contractSettings: {
      lastName: "",
      firstName: "",
      motherChildName: "",
      bornName: "",
      bornCity: "",
      bornDate: "",
      phoneNumberArea: "",
      phoneNumber: "",
      email: "",
      emailVerification: "",
      emailVerified: false,
      emailVerifyToken: "",
      merchantEmail: "",
      postAddressIsTheSame: 1,
      bankAccountNumber: "",
      bankName: "",
      bankAccountHolderName: "",
      postAddress: {
        locationZip: "",
        locationCity: "",
        locationName: "",
        selectedLocationName: null,
        locationType: "",
        locationHouseNumber: "",
        locationBuilding: "",
        locationTopography: "",
      },
    },
    insuredSettings: {
      contractedIsInsured: 1,
      lastName: "",
      firstName: "",
      motherChildName: "",
      bornName: "",
      bornCity: "",
      bornDate: "",
      phoneNumberArea: "",
      phoneNumber: "",
      email: "",
    },
    mortgageSettings: {
      mortgageBank: null,
      propertyIsMortgaged: 0,
      rebuildValue: 0,
      creditor: "",
      creditorLocation: "",
      mortgageId: "",
      mortgageType: "",
      mortgagePrice: 0,
      mortgageCurrency: "HUF",
      mortgageStartDate: null,
      mortgageEndDate: null,
    },
    statementSettings: {
      privacyStatement: false,
      insuranceTerms: false,
      electronicCommunation: false,
      marketingMails: false,
      acceptTerms: false,
      validMerchant: false,
      validDatas: false,
      contrctReasonStatement: false,
      rbnb: false,
    },
    chosenPackage: "",
    availablePackages: {},
    packagePrices: {},
    valaszthatoKiegeszitok: {},
    chosenAccessories: [],
    packageInfo: {},
    upol: false,
    process: "NORMAL",
    stopProcess: {},
    bankCodes: {
      181: "Allianz Bank Zrt.",
      644: "Alsónémedi és Vidéke Takarékszövetkezet, Alsónémedi",
      807: "Általános Közlekedési Hitelszövetkezet",
      175: "Bank of China Zrt.",
      179: "Bank Plus Bank Zrt.",
      131: "BNP Paribas Hungária Bank Zrt.",
      183: "BNP Paribas Magyarországi Fóktelepe",
      101: "Budapest Hitel és Fejlesztési Bank Zrt.",
      107: "CIB Közép-Európai Nemzetközi Bank Zrt.",
      108: "Citibank Budapest Zrt.",
      180: "Cofidis Magyarországi Fóktelep",
      142: "Commerzbank Budapest Zrt.",
      172: "Credigen Bank Zrt.",
      136: "CaLyon Bank Magyarország Zrt.",
      185: "Calyon S.A. Magyarország Bankfóktelepe",
      135: "KDB Bank (Magyarország) Zrt.",
      163: "Deutsche Bank Zrt.",
      177: "Dresdner Bank AG Magyarországi Fóktelepe",
      116: "Erste Bank Hungary Zrt.",
      170: "Ella Első Lakáshitel Kereskedelmi Bank Zrt.",
      168: "FHB Földhitel és Jelzálog Bank Nyrt.",
      182: "FHB Kereskedelmi Bank Zrt.",
      178: "Fortis Bank SA/NV Magyarországi Fóktelepe",
      880: "Fundamenta Lakáskassza Lakástakarékpénztár Zrt.",
      619: "Füzesabony és Vidéke Takarékszövetkezet, Füzesabony",
      603: "Hajdúdorog és Vidéke Takarékszövetkezet",
      114: "Hanwha Bank Magyarország Zrt.",
      162: "HBW Express Takarékszövetkezet",
      109: "UniCredit Bank Hungary Zrt.",
      171: "UniCredit Jelzálogbank Zrt.",
      147: "IC Bank Zrt.",
      111: "Inter-Európa Bank Zrt.",
      137: "ING Bank (Magyarország) Zrt.",
      104: "Kereskedelmi és Hitelbank Zrt.",
      144: "Központi Elszámolóház és Értéktár Zrt. (KELER)",
      100: "Magyar Államkincstár",
      146: "Magyar Fejlesztési Bank Zrt.",
      167: "Magyar Cetelem Bank Zrt.",
      148: "Magyar Export-Import Bank Zrt. (Eximbank)",
      103: "Magyar Külkereskedelmi Bank Nyrt.",
      190: "Magyar Nemzeti Bank",
      115: "Magyar Takarékszövetkezeti Bank Zrt.",
      141: "Magyarországi Volksbank Zrt.",
      503: "Mecsek-Vidéke Takarékszövetkezet, Mecseknádasd",
      128: "Merkantil Bank Zrt.",
      652: "Nagykáta és Vidéke Takarékszövetkezet, Nagykáta",
      184: "Oberbank AG Magyarországi Fóktelepe",
      117: "Országos Takarékpénztár és Kereskedelmi Bank Nyrt.",
      884: "OTP Jelzálogbank Zrt.",
      881: "OTP Lakástakarékpénztár Zrt.",
      655: "Örkényi Takarékszövetkezet, Örkény",
      657: "Pilisvörösvár és Vidéke Takarékszövetkezet, Pilisvörösvár",
      160: "Porsche Bank Hungária Zrt.",
      120: "Raiffeisen Bank Zrt.",
      506: "Siklós és Vidéke Takarékszövetkezet, Siklós",
      527: "Soltvadkert és Vidéke Takarékszövetkezet, Soltvadkert",
      176: "EB und HYPO Bank Burgenland-Sopron Zrt.",
      539: "Szarvas és Vidéke Takarékszövetkezet, Szarvas",
      572: "Szegvár és Vidéke Takarékszövetkezet, Szegvár",
      808: "Széchenyi István Hitelszövetkezet",
      700: "Tiszaföldvár és Vidéke Takarékszövetkezet, Tiszaföldvár",
      803: "Tiszántúli Első Hitelszövetkezet",
      659: "Turai Takarékszövetkezet, Tura",
      121: "Westdeutsche Landesbank ( Hungária) Zrt.",
    },
  };
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: getDefaultState(),

  getters: {
    getField,
    getAllState: (state) => {
      const doNotIncludeArray = [
        //'save_request_uid',
        "canProceedToNextPage",
        "storage_uid",
        "mainBuildingInsuranceChanged",
        "sideBuildingInsuranceChanged",
        "eves_dij_plus",
        "gyakorisag_dij_havi",
        "gyakorisag_szerint_fizetendo_dij",
        "last_interaction",
        "generalErrors",
        "allGoodsPriceChanged",
        "marks",
        "maxertekek",
        "engedmenyek",
        "email_valid_code",
        "last_email",
        "contractorPropertyZipChanged",
        "contractorPropertyName",
        "formSubmitLoading",
        "igeny_azon_href",
        "merchant_id",
        "banks",
        "MFOLoaded",
        "cities",
        "chosenPackage",
        "availablePackages",
        "packagePrices",
        "valaszthatoKiegeszitok",
        "chosenAccessories",
        "packageInfo",
        "upol",
        "couponCode",
        "fieldErrors",
      ];
      const filtered = Object.keys(state)
        .filter((key) => !doNotIncludeArray.includes(key))
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});

      return filtered;
    },
    getDiscountSum: (state) => {
      let total = 0;
      for (const key in state.engedmenyek) {
        if (state.engedmenyek.hasOwnProperty(key)) {
          total += state.engedmenyek[key];
        }
      }
      return total * -1;
    },
    getRisks: (state) => {
      let exceptions = [
        "P040",
        "P042",
        "P043",
        "P044",
        "P046",
        "P002",
        "P017",
        "P045",
      ];
      let accessoryFound = false;
      let accesoriosAr = [];
      for (const key in state.risks) {
        if (exceptions.includes(key)) continue;

        let risk = findValueByKey(state.risks[key], "risks");
        let price = findValueByKey(state.risks[key], "dij");
        if (key === "T001") {
          let filteredDesc = state.risks[key].desc.split(",")[0];
          accesoriosAr.push({
            item_id: key,
            item_name: filteredDesc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        } else {
          accesoriosAr.push({
            item_id: key,
            item_name:
              key === "P200".toString() ? "Kézpénz" : state.risks[key].desc, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: price, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        }
      }
      if (state?.ertektargy_osszesen) {
        accesoriosAr.push({
          item_id: "P040-P042-P043-P044-P046-P045",
          item_name: "Értéktárgyak összesen", //ez legyen a kiegészítő fedezet neve
          affiliation: "Household NOPA",
          coupon: state.couponCode,
          discount: "Na", //Ez legyen 'Na', mert nincs egyenként
          price: state.ertektargy_osszesen, //az adott kieg fedezet ára
          item_brand: "Colonnade",
          item_category: "Household",
        });
      }
      return accesoriosAr;
    },
    getProductDetails: (state) => (idArr) => {
      let detailsArr = [];
      for (const id in idArr) {
        if (idArr[id] in state.risks) {
          detailsArr.push({
            item_id: idArr[id],
            item_name: state.risks[idArr[id]].desc,
          });
        }
      }
      return detailsArr;
    },
    getMainBuildingDetails: (state) => (riskCode) => {
      let mainBuildingArr = state.risks[riskCode]?.desc.split(",");

      if (mainBuildingArr) {
        return {
          area: mainBuildingArr[0],
          wallType: mainBuildingArr[1],
          roofType: mainBuildingArr[2],
        };
      } else {
        return {
          area: "none",
          wallType: "none",
          roofType: "none",
        };
      }
    },
    getSideBuildingsDetails: (state) => (riskCode) => {
      let sideBuildinDetalis = [];
      // if (state.risks[riskCode]?.desc) {
      //   let sideBuildingRiskArr = state.risks[riskCode].desc.slice(0, -1).split(';');
      //   for (let i = 1; i <= sideBuildingRiskArr.length; i++) {
      //     const sideArr = sideBuildingRiskArr[i - 1].split(',');
      //     sideBuildinDetalis.push({
      //       ['sideBuilding' + i]: {
      //         area: sideArr[0].split(':')[1] + 'm2',
      //         wallType: sideArr[1].split(':')[1],
      //         roofType: sideArr[2].split(':')[1],
      //       },
      //     });
      //   }
      // }

      if (state.insuranceSideBuildings.list.length > 1) {
        for (let i = 0; i < state.insuranceSideBuildings.list.length; i++) {
          const sideArr = state.insuranceSideBuildings.list[i];
          sideBuildinDetalis.push({
            ["sideBuilding" + (i + 1)]: {
              area: sideArr.floorArea + "m2",
              wallType: sideArr.wallType,
              roofType: sideArr.roofType,
            },
          });
        }
      }

      return sideBuildinDetalis;
    },
    getAccesories: (state) => {
      let accesoriosAr = [];
      let defaultArr = [
        {
          item_id: "No Accesories",
          item_name: "No Accesories", //ez legyen a kiegészítő fedezet neve
          affiliation: "",
          coupon: "",
          discount: "Na", //Ez legyen 'Na', mert nincs egyenként
          price: 0, //az adott kieg fedezet ára
          item_brand: "",
          item_category: "",
        },
      ];
      for (const key in state.chooseableAccesories.selectableList) {
        if (state.chooseableAccesories.selectableList[key].selected) {
          accesoriosAr.push({
            item_id: state.product_code,
            item_name: state.chooseableAccesories.selectableList[key].name, //ez legyen a kiegészítő fedezet neve
            affiliation: "Household NOPA",
            coupon: state.couponCode,
            discount: "Na", //Ez legyen 'Na', mert nincs egyenként
            price: state.chooseableAccesories.selectableList[key].insuranceFee, //az adott kieg fedezet ára
            item_brand: "Colonnade",
            item_category: "Household",
          });
        }
      }
      if (accesoriosAr.length < 1) {
        return defaultArr;
      } else {
        return accesoriosAr;
      }
      return defaultArr;
    },
  },
  mutations: {
    updateField,
    resetState(state) {
      localStorage.clear();
      Object.assign(state, getDefaultState());
    },
    incrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page < 5) {
        state.page++;
      }
      window.scrollTo(0, 0);
    },
    decrementPage(state, value = null) {
      if (value !== null) {
        state.page = value;
      } else if (!value && state.page > 1) {
        state.page--;
      }

      window.scrollTo(0, 0);
    },
    setProcess(state, value) {
      state.process = value;
    },
    setConnection(state, value) {
      state.connection = value;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setProductCode(state, code) {
      state.product_code = code;
    },
    setStopProcess(state, value) {
      state.stopProcess = value;
    },
    setFormSubmitLoading(state, status) {
      state.formSubmitLoading = status;
    },
    addSideBuilding(state, building) {
      state.insuranceSideBuildings.list.push(building);
    },
    deleteSideBuilding(state, id) {
      state.insuranceSideBuildings.list.splice(id, 1);
    },
    updateSideBuilding(state, data) {
      const index = state.insuranceSideBuildings.list.findIndex(
        (item, index) => index === data.building,
      );
      if (index !== -1)
        state.insuranceSideBuildings.list[index][data.key] = data.value;
    },
    setDefaultAccessory(state, kod) {
      if (state.chosenAccessories[kod].limit) {
        state.chosenAccessories[kod].limit = 1;
      }
      if (state.chosenAccessories[kod].tovabbi_adatok) {
        Object.keys(state.chosenAccessories[kod].tovabbi_adatok).forEach(
          (a) => {
            state.chosenAccessories[kod].tovabbi_adatok[a] = "0";
          },
        );
      }
      if (state.chosenAccessories[kod].biztositottak) {
        state.chosenAccessories[kod].biztositottak = [];
      }
    },
    updateAccesory(state, data) {
      if (data.limit) {
        state.chosenAccessories[data.kod].limit = data.limit;
      }
      if (data.tovabbiAdatok) {
        const code = Object.keys(data.tovabbiAdatok)[0];
        state.chosenAccessories[data.kod].tovabbi_adatok[code] =
          data.tovabbiAdatok[code];
      }
      // if (data.utasInfok) {
      //   state.chosenAccessories[data.kod].utasBiztositottak = data.utasInfok.utasBiztositottak;
      // }

      state.chosenAccessories = { ...state.chosenAccessories };

      // console.log(state.chosenAccessories[data.kod])
    },
    setAccessory(state, kod) {
      state.chosenAccessories[kod].selected = !state.chosenAccessories[kod]
        .selected;
      state.chosenAccessories = { ...state.chosenAccessories };
      // console.log(state.chosenAccessories)
    },
    setPackagePrices(state, data) {
      state.packagePrices = data;
    },
    setMFOLoadedStatus(state, status) {
      state.MFOLoaded = status;
    },

    setUpDefaultChosenAccessory(state, { kod, key, value }) {
      state.chosenAccessories[kod][key] = value;
    },
    // insured persons

    addInsuredPerson(state, data) {
      state.chosenAccessories[data.listName].biztositottak.push(data.person);
    },
    deleteInsuredPerson(state, data) {
      state.chosenAccessories[data.listName].biztositottak.splice(data.id, 1);
    },
    updateInsuredPerson(state, data) {
      const index = state.chosenAccessories[
        data.listName
      ].biztositottak.findIndex((item, index) => index === data.index);
      if (index !== -1)
        state.chosenAccessories[data.listName].biztositottak[index][data.key] =
          data.value;
    },

    //mortgage
    addMortgage(state, data) {
      state.chooseableAccesories[data.listName].list.push(data.person);
    },
    deleteMortgage(state, data) {
      state.chooseableAccesories[data.listName].list.splice(data.id, 1);
    },
    updateMortgage(state, data) {
      const index = state.chooseableAccesories[data.listName].list.findIndex(
        (item, index) => index === data.index,
      );
      if (index !== -1)
        state.chooseableAccesories[data.listName].list[index][data.key] =
          data.value;
    },

    // recommended and chosen insurance prices
    setRecommendedInsurancePriceMain(state, value) {
      state.insuranceProperty.recommendedInsurancePrice = value;
    },
    setRecommendedInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.recommendedInsurancePrice = value;
    },
    setRecommendedPersonalGoodsPrice(state, value) {
      state.insurancePersonalGoods.calculatedInsurancePrice = value;
    },
    setChosenInsurancePriceMain(state, value) {
      state.insuranceProperty.chosenInsurancePrice = value;
    },
    setChosenInsurancePriceSide(state, value) {
      state.insuranceSideBuildings.chosenInsurancePrice = value;
    },
    setChosenPersonalPriceSide(state, value) {
      state.insurancePersonalGoods.allGoodsPrice = value;
    },

    // insurance property town name
    setInsurancePropertyTownName(state, name) {
      state.generalInfo.propertyName = name;
    },
    setContractPostPropertyTownName(state, name) {
      state.contractSettings.postAddress.locationCity = name;
      state.contractorPropertyName = name;
    },
    setCompanyTownName(state, name) {
      state.riskSettings.companyLocationCity = name;
    },

    // update main and side building insurance input state
    setMainInsuranceChangedState(state, value) {
      state.mainBuildingInsuranceChanged = value;
    },
    setSideInsuranceChangedState(state, value) {
      state.sideBuildingInsuranceChanged = value;
    },
    setAllGoodsPriceChangedState(state, value) {
      state.allGoodsPriceChanged = value;
    },
    setRisks(state, value) {
      state.risks = value;
    },
    setFieldErrors(state, value) {
      state.fieldErrors = value;
    },
    setErtektargyOsszesen(state, value) {
      state.ertektargy_osszesen = value;
    },
    setCouponCode(state, value) {
      state.couponCode = value;
    },
    // setBusinessDiscount(state, value) {
    //   state.businessDiscount = value;
    // },
    setMaxDiscount(state, newValue) {
      state.maxDiscount = newValue;
    },
    setPartnertipus(state, value) {
      state.partnertipus = value;
    },
    setFetchUid(state, value) {
      state.fetch_uid = value;
    },
    // page allowing
    setNextPageStatus(state, status) {
      const now = new Date();
      const ONE_HOUR = 60 * 60 * 1000;
      // const ONE_HOUR = 2;

      const date = new Date(state.last_interaction);
      if (now - date > ONE_HOUR * 2) {
        this.commit("setStorageUid", null);
      }
      state.last_interaction = now;
      localStorage.setItem("last_interaction", now);
      state.canProceedToNextPage = status;
    },

    // set yearly price
    setYearlyPrice(state, price) {
      state.chooseableAccesories.accessorySumPrice = price;
    },

    setPlusAccesoriesPrice(state, price) {
      state.eves_dij_plus = price;
    },
    setFrequencyPrice(state, price) {
      state.gyakorisag_szerint_fizetendo_dij = price;
    },
    setMonthlyPrice(state, price) {
      state.gyakorisag_dij_havi = price;
    },

    setYearlyPriceWithAccesories(state, price) {
      state.kieg_emelt_eves_dij = price;
    },

    setYearlyPriceWithDiscounts(state, price) {
      state.kieg_kedv_dij = price;
    },

    setDiscounts(state, discounts) {
      state.engedmenyek = discounts;
    },

    // set max valuables above 200
    setMaxValuablesPrice(state, price) {
      state.chooseableAccesories.valuesAbove200Maximum = price;
    },

    // set email validation code
    setEmailValidationCode(state, { code, email }) {
      state.email_valid_code = code;
      state.last_email = email;
    },

    // storage uid
    setStorageUid(state, uid) {
      if (!uid) {
        state.storage_uid = null;
        //localStorage.removeItem('storage_uid');
      } else {
        state.storage_uid = uid;
        //localStorage.setItem('storage_uid', uid);
      }
    },
    setClaimIdentifierUrl(state, url) {
      state.igeny_azon_href = url;
    },
    setGenerateLink(state, value) {
      state.generatelink = value;
    },
    setMortgagetypes(state, value) {
      state.mortgagetypes = value;
    },

    // update values on load
    setGeneralPropertyValues(state, { name, value }) {
      if (state.generalInfo[name] != undefined) state.generalInfo[name] = value;
    },

    setDmType(state, value) {
      state.dm = value;
    },
    setErtekesitoKoti(state, value) {
      state.ertekesito_koti = value;
    },
    setCityName(state, value) {
      state.generalInfo.selectedPropertyName = value;
    },
    setInsurancePropertyValues(state, { name, value }) {
      if (state.insuranceProperty[name] != undefined)
        state.insuranceProperty[name] = value;
    },

    setInsuranceSidePropertyValues(state, { name, value }) {
      if (state.insuranceSideBuildings[name] != undefined)
        state.insuranceSideBuildings[name] = value;
    },

    setInsurancePersonalGoods(state, { name, value }) {
      if (state.insurancePersonalGoods[name] != undefined)
        state.insurancePersonalGoods[name] = value;
    },

    setChooseableAccesoriesSelected(state, { name, value }) {
      if (state.chooseableAccesories.selectableList[name] != undefined)
        state.chooseableAccesories.selectableList[name].selected = value;
    },

    setChooseableAccesories(state, { name, value }) {
      if (state.chooseableAccesories[name] != undefined)
        state.chooseableAccesories[name] = value;
    },

    setValuablesAboveInputs(state, { name, value }) {
      if (state.chooseableAccesories.valuablesAboveInputs[name] != undefined)
        state.chooseableAccesories.valuablesAboveInputs[name] = value;
    },

    setPaymentOptions(state, { name, value }) {
      if (state.paymentOptions[name] != undefined)
        state.paymentOptions[name] = value;
    },
    setContraceReason(state, value) {
      state.kotes_oka = value;
    },

    setOldBondnumber(state, value) {
      state.regi_kotvenyszam = value;
    },
    setElectronicContact(state, value) {
      state.electronicContact = value;
    },

    setElectronicInsuring(state, value) {
      state.electronicInsuring = value;
    },
    setAgeDiscount(state, value) {
      state.ageDiscount = value;
    },

    updateRiskSettings(state, { name, value }) {
      if (state.riskSettings[name] != undefined)
        state.riskSettings[name] = value;
    },

    updateContractSettings(state, { name, value }) {
      if (state.contractSettings[name] != undefined)
        state.contractSettings[name] = value;
    },

    updateContractPostSettings(state, { name, value }) {
      if (state.contractSettings.postAddress[name] != undefined)
        state.contractSettings.postAddress[name] = value;
    },

    updateInsuredSettings(state, { name, value }) {
      if (state.insuredSettings[name] != undefined)
        state.insuredSettings[name] = value;
    },

    updateMortgageSettings(state, { name, value }) {
      if (
        state.mortgageSettings[name] != undefined ||
        state.mortgageSettings[name] === null
      )
        state.mortgageSettings[name] = value;
    },

    updateStatements(state, { name, value }) {
      if (state.statementSettings[name] != undefined)
        state.statementSettings[name] = value;
    },

    // general errors
    setGeneralErrors(state, errors) {
      errors.forEach((error) => {
        if (!state.generalErrors.includes(error)) Vue.$toast.error(error);
      });
      state.generalErrors = errors;
    },

    setMarks(state, marks) {
      state.marks = marks;
    },

    setBanks(state, banks) {
      state.banks = banks;
    },
    setMaxErtekek(state, maxErtekek) {
      state.maxertekek = maxErtekek;
    },
    setUzletpolitikaiMax(state, uzletpolitikaiMax) {
      state.uzletpolitikai_max = uzletpolitikaiMax;
    },
    //igenyazonosito
    setClaimIdentifier(state, code) {
      state.code = code;
    },
    setDMEmailSent(state, value) {
      state.dm_email_sent = value;
    },
    setSaveURL(state, saveUid) {
      state.save_request_uid = saveUid;
      //console.log('save uid: ' + saveUid);
    },
    setNavigationBackButton(state, value) {
      state.isBackButtonDisabled = value;
    },
    setFetchUrl(state, url) {
      state.fetch_url = url;
    },
    createFetchURL2(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = "";
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        fetchUrl = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
        //console.log(currentUrl.search);
      } else {
        fetchUrl = currentLocation.origin + "/?fetch_uid=" + fetch_uid;
        //console.log('nincs search param');
      }
      //console.log(currentLocation);
      context.commit("setFetchUrl", fetchUrl);
    },
    updateChosenPackage(state, newPackage) {
      state.chosenPackage = newPackage;
      // console.log(state.chosenAccessories)
    },
    setPackageInfo(state, data) {
      state.packageInfo = data;
    },
    setAvailablePackages(state, data) {
      state.availablePackages = data;
    },
    setValaszthatoKiegeszitok(state, data) {
      state.valaszthatoKiegeszitok = data;
    },
    setupChosenAccessories(state, data) {
      data.forEach((kieg) => {
        if (!state.chosenAccessories[kieg[0]]) {
          state.chosenAccessories[kieg[0]] = {
            selected: false,
          };
          if (kieg[1].sokszorozhato && kieg[1].sokszorozhato > 1) {
            state.chosenAccessories[kieg[0]].limit = 1;
          }
          if (kieg[1].tovabbi_adatok) {
            state.chosenAccessories[kieg[0]].tovabbi_adatok = {};
            Object.keys(kieg[1].tovabbi_adatok).forEach((a) => {
              state.chosenAccessories[kieg[0]].tovabbi_adatok[a] = "0";
            });
          }
          if (typeof kieg[1].biztositottak_szama === "number") {
            state.chosenAccessories[kieg[0]].biztositottak = [];
          }
        }
        if (
          state.chosenAccessories[kieg[0]].limit &&
          state.chosenAccessories[kieg[0]].limit > kieg[1].sokszorozhato
        ) {
          state.chosenAccessories[kieg[0]].limit =
            state.chosenAccessories[kieg[0]].limit / kieg[1].limit;
        }
      });

      state.chosenAccessories = { ...state.chosenAccessories };
      // console.log('chosenAccessories setup:')
      // console.log(state.chosenAccessories)
    },
    setUpol(state, data) {
      state.upol = data;
    },
  },

  actions: {
    getMarks(context) {
      const params = new URLSearchParams();

      params.append("marks", 1);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((res) => {
          const data = res.data.data;
          if (data?.marks) {
            context.commit("setMarks", data.marks);
            context.commit("setConnection", data.connection);
            context.dispatch("updateMarks", data.marks);

            if (data.marks.colonnade_version && context.state.page === 1) {
              Swal.fire({
                icon: "info",
                html: `Verzió: ${data.marks.colonnade_version}`,
                showCloseButton: true,
                closeButtonAriaLabel: "× Ablak bezárása",
                showConfirmButton: false,
              });
            }
          }

          if (data?.banks) {
            context.commit("setBanks", data.banks);
          }

          if (data?.error_messages?.code) {
            veeLocalize("hu", data.error_messages);
          }

          if (data?.stop_process) {
            context.commit("setStopProcess", data.stop_process);
          }

          if (data?.maxertekek) {
            context.commit("setMaxErtekek", data.maxertekek);
          }

          if (data?.uzletpolitikai_max) {
            context.commit("setUzletpolitikaiMax", data.uzletpolitikai_max);
          }
          if (data?.jelzalog_tipusok) {
            context.commit("setMortgagetypes", data.jelzalog_tipusok);
          }
        })
        .catch((err) => {
          console.error("Nem sikerült betölteni a marks-okat.");
          console.error(err);
        });
    },
    getStoredData(context) {
      context.commit("setNextPageStatus", false);
      const state = context.state;

      const params = new URLSearchParams();
      params.append("storage_uid", state.storage_uid);

      axios
        .post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        )
        .then((result) => {
          // console.log('előtöltés');

          if (result.data.generalErrors?.length > 0) {
            context.commit("setStorageUid", null);
            //console.log('storage_uid törölve');
            return;
          }

          const data = result.data?.labels?.result?.dump;
          if (data) {
            //console.log('getStoredData: ');
            //console.log(data);

            context.dispatch("loadStateFromData", data);

            context.commit("setNextPageStatus", true);
          } else {
            //context.commit('setStorageUid', null)
            console.error("előtöltés sikertelen, nincs visszakapott adat");
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    async verifyPage(context, tab_id) {
      if (tab_id === 6 && context.state.formSubmitLoading) return;
      context.commit("setNextPageStatus", false);
      const state = context.state;

      if (!document.getElementById("form")) return;

      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      if (tab_id) params.append("tab_id", tab_id);
      else params.append("tab_id", state.page);

      // console.log("current state: " + state.code)
      // console.log("pdf link: " + state.igeny_azon_href)

      if (state.code === "igenyazonosito" && state.igeny_azon_href)
        context.commit("setClaimIdentifier", null);

      if (state.code) params.append("kod", state.code);

      if (state.generatelink === 1)
        params.append("generatelink", state.generatelink);

      let buildings = "";

      state.insuranceSideBuildings.list.forEach((building) => {
        const data = `mellekepulet_alapterulet:${building.floorArea},mellekepulet_falazat:${building.wallType},mellekepulet_tetozet:${building.roofType};`;
        buildings += data;
      });

      // temp params
      // params.append('valasztott_csomag', 'mini');
      // params.append('dijfizetes_gyakorisag', 'eves');
      // params.append('ekarrendezes', 1);
      // params.append('dijfizetes_mod', 'online');
      // params.append('ekommunikacio', 1);
      // params.append('ingosag_osszesen', 65000);

      params.append("mellekepuletek", buildings);

      if (state.partnertipus != "")
        params.append("partnertipus", state.partnertipus);
      Object.keys(state.chosenAccessories).forEach((kieg) => {
        if (
          state.chosenAccessories[kieg].biztositottak &&
          state.chosenAccessories[kieg].selected
        ) {
          let insuredPersons = "";

          state.chosenAccessories[kieg].biztositottak.forEach((person) => {
            let bornDate = person.bornDate;
            if (bornDate instanceof Date) {
              bornDate = new Date(
                new Date(bornDate).getFullYear(),
                new Date(bornDate).getMonth(),
                new Date(bornDate).getDate() + 1,
              )
                .toISOString()
                .split("T")[0];
            }
            const data = `nev:${person.name || ""},szuletesi_datum:${bornDate ||
              ""};`;
            insuredPersons += data;
          });
          const keyName = `${
            kieg === "utasbiztositas" ? "utas" : kieg
          }_biztositottak`;
          params.append(keyName, insuredPersons);
        }
      });

      // if (state.chosenAccessories.utasbiztositas) {
      //   let insuredPersons = '';

      //   state.chooseableAccesories.travelInsuranced.list.forEach((person) => {
      //     let bornDate = person.bornDate;
      //     if (bornDate instanceof Date) {
      //       bornDate = bornDate.toISOString().split('T')[0];
      //     }

      //     const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
      //     insuredPersons += data;
      //   });

      //   params.append('utas_biztositottak', insuredPersons);
      // } else {
      //   params.append('utas_biztositottak', '');
      // }

      // if (state.chooseableAccesories.selectableList.kegyeleti.selected) {
      //   let insuredPersons = '';

      //   state.chooseableAccesories.burialInsuranced.list.forEach((person) => {
      //     let bornDate = person.bornDate;
      //     if (bornDate instanceof Date) {
      //       bornDate = bornDate.toISOString().split('T')[0];
      //     }

      //     const data = `nev:${person.name || ''},szuletesi_datum:${bornDate || ''};`;
      //     insuredPersons += data;
      //   });

      //   params.append('temetes_biztositottak', insuredPersons);
      // } else {
      //   params.append('temetes_biztositottak', '');
      // }

      if (state.chooseableAccesories.mortgage.list.length > 0) {
        let mortgages = "";
        state.chooseableAccesories.mortgage.list.forEach((mortgage) => {
          let mortgageStartDate = mortgage.mortgageStartDate;

          if (mortgageStartDate instanceof Date) {
            mortgageStartDate = mortgageStartDate.toISOString().split("T")[0];
          }
          let mortgageEndDate = mortgage.mortgageEndDate;

          if (mortgageEndDate instanceof Date) {
            mortgageEndDate = mortgageEndDate.toISOString().split("T")[0];
          }
          const data = `hitelezo_azon:${mortgage.mortgageBank ||
            ""},hitelezo_neve:${mortgage.creditor ||
            ""},hitelezo_cime:${mortgage.creditorLocation ||
            "-"},hitel_tipusa:${mortgage.mortgageType},hitel_azonosito:${
            mortgage.mortgageId
          },hitel_osszege:${mortgage.mortgagePrice},hitel_penznem:${
            mortgage.mortgageCurrency
          },hitel_kezdete:${mortgageStartDate ||
            "-"},hitel_lejarat:${mortgageEndDate || "-"};`;
          mortgages += data;
        });
        params.append("jelzalog_egyeb", mortgages);
      }

      if (params.has("ingatlan_erteke")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceProperty.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceProperty.chosenInsurancePrice || 0;
        }
        params.set("ingatlan_erteke", money);
      }
      if (params.has("rbnb_berletidij")) {
        let money = 0;
        try {
          money = parseMoney(
            state.generalInfo.rbnbPrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.generalInfo.rbnbPrice || 0;
        }
        params.set("rbnb_berletidij", money);
      }

      if (params.has("valasztott_ar_mellekepulet")) {
        let money = 0;
        try {
          money = parseMoney(
            state.insuranceSideBuildings.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = state.insuranceSideBuildings.chosenInsurancePrice || 0;
        }
        params.set("valasztott_ar_mellekepulet", money || 0);
      }

      if (params.has("ingosag_osszesen")) {
        let money = 0;
        try {
          money = parseMoney(
            params.get("ingosag_osszesen"),
            window.currencyInputOptions,
          );
        } catch (e) {
          money = parseInt(params.get("ingosag_osszesen")) || 0;
        }
        params.set("ingosag_osszesen", money);
      }

      // 2nd page

      const kiegekExtra = Object.keys(state.chosenAccessories).filter(
        (kieg) => state.chosenAccessories[kieg].tovabbi_adatok,
      );
      kiegekExtra.forEach((k) => {
        Object.keys(state.chosenAccessories[k].tovabbi_adatok).forEach((a) => {
          if (params.has(a)) {
            params.set(
              a,
              parseMoney(
                state.chosenAccessories[k].tovabbi_adatok[a],
                window.currencyInputOptions,
              ) || 0,
            );
          }
        });
      });

      // if (state.chosenAccessories.ertektargy?.selected) {
      //   let ertektargySum = 0
      //   Object.values(state.chosenAccessories.ertektargy.tovabbi_adatok).forEach(a => {
      //     if (typeof a === 'number') {
      //       ertektargySum += a
      //     } else {
      //       ertektargySum += parseMoney(a, window.currencyInputOptions) || 0
      //     }
      //   })
      //   params.append('ertektargy_osszesen', ertektargySum)
      // }

      // if (params.has('ekszerek'))
      //   params.set(
      //     'ekszerek',
      //     parseMoney(
      //       state.chosenAccessories,
      //       window.currencyInputOptions
      //     ) || 0
      //   );
      // if (params.has('antik_butorok'))
      //   params.set(
      //     'antik_butorok',
      //     parseMoney(
      //       state.chooseableAccesories.valuablesAboveInputs.antiques,
      //       window.currencyInputOptions
      //     ) || 0
      //   );
      // if (params.has('szormek'))
      //   params.set(
      //     'szormek',
      //     parseMoney(
      //       state.chooseableAccesories.valuablesAboveInputs.exotic,
      //       window.currencyInputOptions
      //     ) || 0
      //   );
      // if (params.has('gyujtemeny'))
      //   params.set(
      //     'gyujtemeny',
      //     parseMoney(
      //       state.chooseableAccesories.valuablesAboveInputs.collection,
      //       window.currencyInputOptions
      //     ) || 0
      //   );
      // if (params.has('kepzomuveszeti'))
      //   params.set(
      //     'kepzomuveszeti',
      //     parseMoney(
      //       state.chooseableAccesories.valuablesAboveInputs.fineart,
      //       window.currencyInputOptions
      //     ) || 0
      //   );

      // if (params.has('termes_termeny'))
      //   params.set(
      //     'termes_termeny',
      //     parseMoney(state.chooseableAccesories.farmingStock, window.currencyInputOptions) || 0
      //   );
      // if (params.has('allatallomany'))
      //   params.set(
      //     'allatallomany',
      //     parseMoney(state.chooseableAccesories.farmingAnimals, window.currencyInputOptions) || 0
      //   );
      // if (params.has('gepek_felszereles'))
      //   params.set(
      //     'gepek_felszereles',
      //     parseMoney(state.chooseableAccesories.farmingTools, window.currencyInputOptions) || 0
      //   );

      // if (params.has('kiemeltingosag_osszeg'))
      //   params.set(
      //     'kiemeltingosag_osszeg',
      //     parseMoney(state.chooseableAccesories.priorityProperty, window.currencyInputOptions) || 0
      //   );

      if (
        params.get("szerzodo_email") &&
        params.get("szerzodo_email_2") &&
        (!state.email_valid_code ||
          state.last_email != state.contractSettings.email) &&
        state.contractSettings.lastName
      ) {
        const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (
          !emailRegex.test(params.get("szerzodo_email")) &&
          !emailRegex.test(params.get("szerzodo_email_2"))
        ) {
          if (state.generatelink === 0) return;
        }
        if (
          state.contractSettings.email ===
          state.contractSettings.emailVerification
        )
          params.set("sendvalidemail", 1);
      }

      if (params.has("biztositas_targya")) {
        const targya = params.get("biztositas_targya");

        if (targya == "ingatlan") params.set("ingosag_osszesen", 0);
        if (targya == "ingosag") params.set("ingatlan_erteke", 0);
      }

      // setting uid param if stored
      if (state.storage_uid) params.set("storage_uid", state.storage_uid);
      if (state.merchant_id) params.set("merchant_id", state.merchant_id);

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );

        if (tab_id === 6) context.commit("setFormSubmitLoading", false);

        // console.log('verifyPage: ');
        // console.log(result.data);
        // console.log('state: ');
        // console.log(state);
        // console.log(state.storage_uid);

        let data = result.data;

        context.commit("setFieldErrors", data?.fieldErrors ?? {});

        if (data.fieldErrors?.length <= 0 && data.generalErrors?.length <= 0) {
          context.commit("setNextPageStatus", true);
        }

        if (
          Object.keys(data?.fieldErrors ?? {}).length <= 1 &&
          data.fieldErrors?.hasOwnProperty("kedvezmenykod") &&
          data.generalErrors?.length <= 0
        ) {
          console.log("fieldErrors: engedés ");
          console.log(data.fieldErrors);
          context.commit("setNextPageStatus", true);
        }

        if (data.connection !== state.connection) {
          context.commit("setConnection", data.data.connection);
        }
        //if(data.generalErrors.includes('#T2 storage UID is null')) context.commit('incrementPage', 1)

        context.commit("setGeneralErrors", data.generalErrors);
        if (data.labels) {
          const labels = data.labels;

          if (labels?._save_request_response?.saved_request_uid) {
            context.commit(
              "setSaveURL",
              labels._save_request_response.saved_request_uid,
            );
            // context.dispatch(
            //   'navigateToSaveUrl',
            //   labels._save_request_response.saved_request_uid
            // );
            //console.log('van _save_request_uid');
            context.dispatch(
              "createFetchURL",
              labels._save_request_response.saved_request_uid,
            );
            //console.log('van _save_request_uid createFetch után');
            context.commit("setGenerateLink", 0);
            context.commit("setSaveURL", "");
          }

          if (labels.ajanlott_osszeg_foepulet) {
            context.commit(
              "setRecommendedInsurancePriceMain",
              labels.ajanlott_osszeg_foepulet,
            );
            // console.log(state.mainBuildingInsuranceChanged)
            if (
              !state.mainBuildingInsuranceChanged ||
              !state.insuranceProperty.chosenInsurancePrice
            )
              context.commit(
                "setChosenInsurancePriceMain",
                labels.ajanlott_osszeg_foepulet,
              );
          }
          if (labels.ajanlott_osszeg_mellekepulet) {
            context.commit(
              "setRecommendedInsurancePriceSide",
              labels.ajanlott_osszeg_mellekepulet,
            );
            if (
              !state.sideBuildingInsuranceChanged &&
              labels.ajanlott_osszeg_mellekepulet !=
                state.insuranceSideBuildings.chosenInsurancePrice
            )
              context.commit(
                "setChosenInsurancePriceSide",
                labels.ajanlott_osszeg_mellekepulet,
              );
          }
          if (labels.ingosagok_ajanlott_ar) {
            context.commit(
              "setRecommendedPersonalGoodsPrice",
              labels.ingosagok_ajanlott_ar,
            );
            if (
              !state.allGoodsPriceChanged &&
              labels.ingosagok_ajanlott_ar !=
                state.insurancePersonalGoods.allGoodsPrice
            )
              context.commit(
                "setChosenPersonalPriceSide",
                labels.ingosagok_ajanlott_ar,
              );
          }

          if (labels.result) {
            const save = labels.result;
            const dbDump = labels.result.dump;

            if (save.validation_code_base64) {
              if (save.validation_code_base64)
                context.commit("setEmailValidationCode", {
                  code: save.validation_code_base64,
                  email: state.contractSettings.email,
                });
            } else {
              if (save.id) context.commit("setStorageUid", labels.result.id);
              context.commit(
                "setYearlyPrice",
                dbDump.dijak_biztosszegek?.dij
                  ?.valasztott_csomag_eves_dija_kedvezmeny_nelkul || 0,
              );
              context.commit(
                "setPlusAccesoriesPrice",
                dbDump.dijak_biztosszegek?.dij
                  ?.valasztott_kiegeszitok_eves_dija_kedvezmeny_nelkul || 0,
              );
              context.commit("setFrequencyPrice", dbDump.gyakorisagdij || 0);
              context.commit("setMonthlyPrice", dbDump.havidij || 0);
              context.commit(
                "setYearlyPriceWithAccesories",
                dbDump.eves_dij || 0,
              );
              context.commit(
                "setYearlyPriceWithDiscounts",
                dbDump.eves_dij_csokkentett || 0,
              );
              if (dbDump?.engedmenyek) {
                const engedmenyek = dbDump.engedmenyek;

                if (engedmenyek.csoportos)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csoportos;
                else if (engedmenyek.online)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.online;
                else if (engedmenyek.atutalas)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.atutalas;
                else if (engedmenyek.csekk)
                  engedmenyek.fizetesi_mod_kedvezmeny = engedmenyek.csekk;
                else engedmenyek.fizetesi_mod_kedvezmeny = null;

                if (engedmenyek.eves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.eves;
                else if (engedmenyek.feleves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.feleves;
                else if (engedmenyek.negyedeves)
                  engedmenyek.dijfizetes_gyakorisag_kedvezmeny =
                    engedmenyek.negyedeves;
                else engedmenyek.dijfizetes_gyakorisag_kedvezmeny = null;

                context.commit("setDiscounts", engedmenyek);
              }
              if (dbDump?.igeny_azon_href) {
                if (dbDump.igeny_azon_href !== context.igeny_azon_href) {
                  context.commit("setClaimIdentifierUrl", null);
                }
                context.commit("setClaimIdentifierUrl", dbDump.igeny_azon_href);
              } else {
                context.commit("setClaimIdentifierUrl", null);
              }
              if (dbDump?.PRODUCT_CODE) {
                context.commit("setProductCode", dbDump.PRODUCT_CODE);
              }
              if (dbDump?.risks) {
                context.commit("setRisks", dbDump.risks);
              }
              if (dbDump?.ertektargy_osszesen) {
                context.commit(
                  "setErtektargyOsszesen",
                  dbDump.ertektargy_osszesen,
                );
              }
              // if (dbDump?.kedvezmenykod) {
              //   context.commit("setCouponCode", dbDump.kedvezmenykod);
              // }
              if (dbDump?.partnertipus) {
                context.commit("setPartnertipus", dbDump.partnertipus);
              }
            }

            if (dbDump.upol) {
              context.commit("setUpol", dbDump.upol);
            }
          }
        }

        // console.log('verifyPage engedmeny utan: ');
        // console.log(result.data);
        // console.log('state engedmeny utan: ');
        // console.log(state);

        if (data.data) {
          data = result.data.data;

          // console.log(data.process);

          if (data.process !== context.state.process) {
            // console.log('changing process to this: ' + data.process);
            context.commit("setProcess", data.process);
          }

          if (data.dijak_biztosszegek?.ajanlottbiztosszeg) {
            context.commit(
              "setRecommendedInsurancePriceMain",
              data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet,
            );
            context.commit(
              "setRecommendedPersonalGoodsPrice",
              data.dijak_biztosszegek.ajanlottbiztosszeg.ingosag,
            );
            context.commit(
              "setRecommendedInsurancePriceSide",
              data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet,
            );
            if (!state.insuranceProperty.chosenInsurancePrice) {
              context.commit(
                "setChosenInsurancePriceMain",
                data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet,
              );
            }
            // context.commit(
            //   'setChosenInsurancePriceMain',
            //   data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet
            // );
            // console.log('mellekepulet chosen: ' + data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet)
            // context.commit(
            //   'setChosenInsurancePriceSide',
            //   data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet
            // )
            // context.commit(
            //   'setChosenPersonalPriceSide',
            //   data.dijak_biztosszegek.ajanlottbiztosszeg.ingosag
            // )
          }

          if (data.dijak_biztosszegek?.dij?.csomag) {
            // console.log("árak: ")
            // console.log(data.dijak_biztosszegek?.dij?.csomag)
            context.commit(
              "setPackagePrices",
              data.dijak_biztosszegek?.dij?.csomag,
            );
          }

          if (data.dijak_biztosszegek?.dij?.osszkedvezmeny) {
            context.commit(
              "setMaxDiscount",
              data.dijak_biztosszegek?.dij?.osszkedvezmeny,
            );
          }

          if (data.csomagadatok) {
            context.commit("setPackageInfo", data.csomagadatok);
          }

          if (data.csomagszerkezet) {
            context.commit("setAvailablePackages", data.csomagszerkezet);
          }

          if (data.valaszthato_kiegeszitok) {
            context.commit(
              "setValaszthatoKiegeszitok",
              data.valaszthato_kiegeszitok,
            );
            let kiegeszitok = [];
            Object.keys(data.valaszthato_kiegeszitok).forEach((p) =>
              kiegeszitok.push(Object.entries(data.valaszthato_kiegeszitok[p])),
            );
            context.commit("setupChosenAccessories", kiegeszitok.flat());
          }

          if (data.dm) {
            context.commit("setDmType", data.dm);
          }
          if (data.ertekesito_koti) {
            context.commit("setErtekesitoKoti", data.ertekesito_koti);
          }

          if (data.telepules)
            context.commit("setInsurancePropertyTownName", data.telepules);
          else
            context.commit(
              "setInsurancePropertyTownName",
              "Hibás irányítószám",
            );

          if (data.ertektargy_max)
            context.commit("setMaxValuablesPrice", data.ertektargy_max);

          if (!state.contractorPropertyZipChanged) {
            if (data.szerzodo_levelezes_telepules) {
              context.commit(
                "setContractPostPropertyTownName",
                data.szerzodo_levelezes_telepules,
              );
            } else {
              context.commit(
                "setContractPostPropertyTownName",
                "Hibás irányítószám",
              );
            }
            if (
              data.szekhely_telepules &&
              typeof data.szekhely_telepules == "string"
            ) {
              context.commit("setCompanyTownName", data.szekhely_telepules);
            } else {
              context.commit("setCompanyTownName", "");
            }
          }

          if (data.veglegesites_uzenet) {
            context.commit("setStorageUid", null);
            const message = data.veglegesites_uzenet;
            if (message.endsWith(".html")) {
              axios
                .get(message)
                .then((res) => {
                  if (res.data) {
                    Swal.fire({
                      icon: "info",
                      html: res.data,
                      showCloseButton: true,
                      closeButtonAriaLabel: "× Ablak bezárása",
                      showConfirmButton: false,
                      customClass: {
                        content: "text-align-left",
                      },
                    });
                  }
                })
                .catch(() => {
                  Vue.$toast.error(
                    "Hiba történt a tartalom betöltése közben. Keressen fel minket valamelyik elérhetőségünkön.",
                  );
                });
            } else if (
              message.startsWith("http://") ||
              message.startsWith("https://")
            ) {
              window.location = message;
            } else {
              Vue.$toast.info(message);
            }
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
      // console.log('storage_uid a verifyPage végén:' + context.state.storage_uid);
      // console.log('href a verifyPage végén:' + context.state.igeny_azon_href);
      //console.log('state');
      //console.log(this.state);
    },
    async getcovers(context, tab_id) {
      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();
      for (let [key, val] of formData.entries()) params.append(key, val);
      let store = context.state;

      params.append("kod", "getcovers");

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = result.data.data;
        if (data) {
          if (data.process) {
            // console.log('data');
            // console.log(data);
            // context.commit('setProcess', data.process);
          }
        }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    async getPremium(context, tab_id) {
      const formData = new FormData(document.getElementById("form"));
      const params = new URLSearchParams();

      for (let [key, val] of formData.entries()) params.append(key, val);

      let store = context.state;
      params.append("kod", "getpremium");
      if (store.merchant_id) params.set("merchant_id", store.merchant_id);

      if (params.has("ingatlan_erteke")) {
        params.delete("ingatlan_erteke");
      }

      let buildings = "";

      store.insuranceSideBuildings.list.forEach((building) => {
        const data = `mellekepulet_alapterulet:${building.floorArea},mellekepulet_falazat:${building.wallType},mellekepulet_tetozet:${building.roofType};`;
        buildings += data;
      });

      params.append("mellekepuletek", buildings);

      if (params.has("valasztott_ar_mellekepulet")) {
        let money = 0;
        try {
          money = parseMoney(
            store.insuranceSideBuildings.chosenInsurancePrice,
            window.currencyInputOptions,
          );
        } catch (e) {
          money = store.insuranceSideBuildings.chosenInsurancePrice || 0;
        }
        params.set("valasztott_ar_mellekepulet", money || 0);
      }

      try {
        const result = await axios.post(
          `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`,
          params,
        );
        let data = result.data.data;
        // console.log(result);
        // console.log(data.premium);
        if (data) {
          if (data.dijak_biztosszegek?.ajanlottbiztosszeg) {
            context.commit(
              "setRecommendedInsurancePriceMain",
              data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet,
            );
            context.commit(
              "setRecommendedPersonalGoodsPrice",
              data.dijak_biztosszegek.ajanlottbiztosszeg.ingosag,
            );
            context.commit(
              "setRecommendedInsurancePriceSide",
              data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet,
            );

            if (!store.mainBuildingInsuranceChanged) {
              context.commit(
                "setChosenInsurancePriceMain",
                data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet,
              );
            }
            // context.commit(
            //   'setChosenInsurancePriceMain',
            //   data.dijak_biztosszegek.ajanlottbiztosszeg.foepulet
            // );
            // console.log('mellekepulet chosen: ' + data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet)
            if (!store.sideBuildingInsuranceChanged) {
              context.commit(
                "setChosenInsurancePriceSide",
                data.dijak_biztosszegek.ajanlottbiztosszeg.mellekepulet,
              );
            }
            if (!store.allGoodsPriceChanged) {
              context.commit(
                "setChosenPersonalPriceSide",
                data.dijak_biztosszegek.ajanlottbiztosszeg.ingosag,
              );
            }
          }

          if (data.dijak_biztosszegek?.dij?.csomag) {
            // console.log("árak: ")
            // console.log(data.dijak_biztosszegek?.dij?.csomag)
            context.commit(
              "setPackagePrices",
              data.dijak_biztosszegek?.dij?.csomag,
            );
          }

          if (data.dijak_biztosszegek?.dij?.osszkedvezmeny) {
            context.commit(
              "setMaxDiscount",
              data.dijak_biztosszegek?.dij?.osszkedvezmeny,
            );
          }

          if (data.csomagadatok) {
            context.commit("setPackageInfo", data.csomagadatok);
          }

          if (data.csomagszerkezet) {
            context.commit("setAvailablePackages", data.csomagszerkezet);
          }

          if (data.valaszthato_kiegeszitok) {
            context.commit(
              "setValaszthatoKiegeszitok",
              data.valaszthato_kiegeszitok,
            );
            let kiegeszitok = [];
            Object.keys(data.valaszthato_kiegeszitok).forEach((p) =>
              kiegeszitok.push(Object.entries(data.valaszthato_kiegeszitok[p])),
            );
            context.commit("setupChosenAccessories", kiegeszitok.flat());
          }
        }

        if (data.csomagadatok) {
          context.commit("setPackageInfo", data.csomagadatok);
        }

        if (data.csomagszerkezet) {
          context.commit("setAvailablePackages", data.csomagszerkezet);
        }

        // if (data.valaszthato_kiegeszitok) {
        //   context.commit('setValaszthatoKiegeszitok', data.valaszthato_kiegeszitok);
        // }

        return Promise.resolve(result);
      } catch (err) {
        if (tab_id === 6) context.commit("setFormSubmitLoading", false);
        Vue.$toast.error(
          "Hiba történt a kapcsolat létrehozása közben. Kérjük keresse fel egyik munkatársunkat az info@colonnade.hu e-mail címen.",
        );

        return Promise.reject(err);
      }
    },
    loadStateFromData(context, data) {
      const state = context.state;
      if (data.biztositas_targya) {
        let result = 1;
        if (data.biztositas_targya == "ingatlan") result = 2;
        if (data.biztositas_targya == "ingosag") result = 3;
        context.commit("setGeneralPropertyValues", {
          name: "contractFor",
          value: result,
        });
      }

      if (data.ingatlan_tipus)
        context.commit("setGeneralPropertyValues", {
          name: "propertyType",
          value: data.ingatlan_tipus,
        });
      if ("allando_lakott" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyInhabitated",
          value: parseInt(data.allando_lakott),
        });
      if ("kulterulet" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyOutskirts",
          value: data.kulterulet ? 1 : 0,
        });
      if ("kulterulet" in data)
        context.commit("setGeneralPropertyValues", {
          name: "rebuild_building",
          value: data.ujraepites ? 1 : 0,
        });
      if ("fizikai" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyPhysicalJob",
          value: data.fizikai ? 1 : 0,
        });

      //load from link propertyPhysicalJobName
      if ("fizikai_megnev" in data)
        context.commit("setGeneralPropertyValues", {
          name: "propertyPhysicalJobName",
          value: data.fizikai_megnev,
        });
      if (data.tulajdonjog)
        context.commit("setGeneralPropertyValues", {
          name: "propertyOwnRight",
          value: data.tulajdonjog,
        });
      if (data.iranyitoszam)
        context.commit("setGeneralPropertyValues", {
          name: "propertyZip",
          value: data.iranyitoszam,
        });
      if (data.telepules)
        context.commit("setGeneralPropertyValues", {
          name: "selectedPropertyName",
          value: data.telepules,
        });
      if (data.telepules) context.commit("setCityName", data.telepules);

      // insurance property
      if (data.alapterulet)
        context.commit("setInsurancePropertyValues", {
          name: "floorArea",
          value: data.alapterulet,
        });
      if (data.epites_eve)
        context.commit("setInsurancePropertyValues", {
          name: "builtYear",
          value: data.epites_eve,
        });
      if (data.lakok_szama)
        context.commit("setInsurancePropertyValues", {
          name: "residents",
          value: data.lakok_szama,
        });
      if (data.foepulet_falazat)
        context.commit("setInsurancePropertyValues", {
          name: "wallType",
          value: data.foepulet_falazat,
        });
      if (data.foepulet_teto)
        context.commit("setInsurancePropertyValues", {
          name: "roofType",
          value: data.foepulet_teto,
        });
      if (data.foepulet?.ajl_min_osszeg)
        context.commit("setInsurancePropertyValues", {
          name: "recommendedInsurancePrice",
          value: data.foepulet.ajl_min_osszeg,
        });
      if (data.ingatlan_erteke) {
        context.commit("setInsurancePropertyValues", {
          name: "chosenInsurancePrice",
          value: parseInt(data.ingatlan_erteke) || 0,
        });
        context.commit("setMainInsuranceChangedState", true);
      }
      if (data.ujraepites_ingatlan) {
        context.commit("setGeneralPropertyValues", {
          name: "rebuild_building",
          value: parseInt(data.ujraepites_ingatlan),
        });
      }
      if (data.ujraepites_ingosag) {
        context.commit("setGeneralPropertyValues", {
          name: "rebuild_ingosag",
          value: parseInt(data.ujraepites_ingosag),
        });
      }
      if (data.valasztott?.foepulet_biztosszeg) {
        if (
          parseInt(data.valasztott?.foepulet_biztosszeg) !=
          parseInt(data.dijak_biztosszegek?.ajanlottbiztosszeg?.foepulet)
        ) {
          context.commit("setMainInsuranceChangedState", true);
        }
        context.commit("setInsurancePropertyValues", {
          name: "chosenInsurancePrice",
          value: data.valasztott?.foepulet_biztosszeg,
        });
      }

      if (data.rbnb) {
        context.commit("setGeneralPropertyValues", {
          name: "rbnb",
          value: parseInt(data.rbnb[0]),
        });
      }
      if (data.rbnb_berletidij) {
        context.commit("setGeneralPropertyValues", {
          name: "rbnbPrice",
          value: parseInt(data.rbnb_berletidij),
        });
      }

      // side buildings
      if (data.mellekepuletek) {
        const mellekepuletek = data.mellekepuletek;
        if (typeof mellekepuletek === "string") {
          const buildings = data.mellekepuletek.split(";");
          buildings.forEach((building) => {
            const inputs = building.split(",");
            if (inputs.length > 1) {
              const inserted = Object.assign(
                {},
                state.insuranceSideBuildings.template,
              );
              inputs.forEach((input) => {
                const split = input.split(":");
                if (split[0] == "mellekepulet_alapterulet")
                  inserted.floorArea = parseInt(split[1]);
                if (split[0] == "mellekepulet_falazat")
                  inserted.wallType = split[1];
                if (split[0] == "mellekepulet_tetozet")
                  inserted.roofType = split[1];
              });
              context.commit("addSideBuilding", inserted);
            }
          });
        } else if (typeof mellekepuletek === "object") {
          mellekepuletek.forEach((sidebuilding) => {
            const inserted = Object.assign(
              {},
              state.insuranceSideBuildings.template,
            );
            inserted.floorArea = sidebuilding.mellekepulet_alapterulet;
            inserted.wallType = sidebuilding.mellekepulet_falazat;
            inserted.roofType = sidebuilding.mellekepulet_teto;
            context.commit("addSideBuilding", inserted);
          });
        }
      }
      if (data.mellekepulet?.ajl_min_osszeg)
        context.commit("setInsuranceSidePropertyValues", {
          name: "recommendedInsurancePrice",
          value: data.mellekepulet.ajl_min_osszeg,
        });
      if (data.valasztott_ar_mellekepulet) {
        if (
          parseInt(data.valasztott?.mellekepulet_biztosszeg || 0) !=
          parseInt(
            data.dijak_biztosszegek?.ajanlottbiztosszeg?.mellekepulet || 0,
          )
        ) {
          context.commit("setSideInsuranceChangedState", true);
          context.commit(
            "setChosenInsurancePriceSide",
            parseInt(data.valasztott?.mellekepulet_biztosszeg) || 0,
          );
          context.commit("setInsuranceSidePropertyValues", {
            name: "chosenInsurancePrice",
            value: parseInt(data.valasztott?.mellekepulet_biztosszeg) || 0,
          });
        } else {
          context.commit(
            "setChosenInsurancePriceSide",
            parseInt(
              data.dijak_biztosszegek?.ajanlottbiztosszeg?.mellekepulet,
            ) || 0,
          );
          context.commit("setInsuranceSidePropertyValues", {
            name: "chosenInsurancePrice",
            value:
              parseInt(
                data.dijak_biztosszegek?.ajanlottbiztosszeg?.mellekepulet,
              ) || 0,
          });
        }
        // context.commit('setSideInsuranceChangedState', true);
      }

      // load from link - personal goods
      if ("ajanlott_bizt_osszeg_elfogad" in data)
        context.commit("setInsurancePersonalGoods", {
          name: "acceptCalculatedInsurance",
          value: parseInt(data.ajanlott_bizt_osszeg_elfogad),
        });
      // personal goods
      if ("ingosag_intezmenyi_szamitas" in data)
        context.commit("setInsurancePersonalGoods", {
          name: "acceptCalculatedInsurance",
          value: data.ingosag_intezmenyi_szamitas ? 1 : 0,
        });
      if (data.valasztott?.ingosag_biztosszeg) {
        if (
          parseInt(data.valasztott?.ingosag_biztosszeg || 0) !=
          parseInt(data.dijak_biztosszegek?.ajanlottbiztosszeg?.ingosag || 0)
        ) {
          context.commit("setAllGoodsPriceChangedState", true);
          context.commit("setInsurancePersonalGoods", {
            name: "allGoodsPrice",
            value: parseInt(data.valasztott?.ingosag_biztosszeg),
          });
        } else {
          context.commit("setInsurancePersonalGoods", {
            name: "allGoodsPrice",
            value: parseInt(
              data.dijak_biztosszegek?.ajanlottbiztosszeg?.ingosag,
            ),
          });
        }
      }

      if (data.haztartasigepek)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "household",
          value: parseInt(data.haztartasigepek),
        });
      if (data.telekommunikacios_eszkozok)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "telecom",
          value: parseInt(data.telekommunikacios_eszkozok),
        });
      if (data.butorok)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "furniture",
          value: parseInt(data.butorok),
        });
      if (data.ruha_labbeli)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "clothes",
          value: parseInt(data.ruha_labbeli),
        });
      if (data.konyhai_es_furdoszobai)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "kitchen",
          value: parseInt(data.konyhai_es_furdoszobai),
        });
      if (data.textilek)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "textile",
          value: parseInt(data.textilek),
        });
      if (data.egyeb)
        context.commit("setInsurancePersonalGoodsInputs", {
          name: "other",
          value: parseInt(data.egyeb),
        });

      // chosen package
      if (data.valasztott_csomag) {
        context.commit("updateChosenPackage", data.valasztott_csomag);
      }

      const valasztottFedezetek = data.valasztott.kiegeszitok;
      Object.keys(valasztottFedezetek).forEach((kieg) => {
        // console.log("kieg:" + kieg)
        // setting accessory to selected
        context.state.chosenAccessories[kieg] = { selected: true };
        // console.log("setting to selected: ")
        // console.log(context.state.chosenAccessories[kieg])

        if (kieg === "kiemeltingosag") {
          context.state.chosenAccessories[kieg].tovabbi_adatok = {};
          context.commit("updateAccesory", {
            kod: kieg,
            limit: null,
            tovabbiAdatok: { kiemeltingosag_osszeg: 0 },
            utasInfok: null,
          });
        }
        if (kieg === "temetes") {
          context.state.chosenAccessories[kieg].biztositottak = [];
          context.commit("addInsuredPerson", {
            person: { name: "", bornDate: null },
            listName: kieg,
          });
        }
        // setting limit, if it had a chooseable limit section (sokszorozhato)
        if (typeof valasztottFedezetek[kieg].limit === "string") {
          context.commit("updateAccesory", {
            kod: kieg,
            limit: Number(valasztottFedezetek[kieg].limit),
            tovabbiAdatok: null,
            utasInfok: null,
          });
        }

        // setting further details in special accessories (tovabbi_adatok)
        if (valasztottFedezetek[kieg].reszletes) {
          context.commit("setUpDefaultChosenAccessory", {
            kod: kieg,
            key: "tovabbi_adatok",
            value: {},
          });
          // console.log(context.state.chosenAccessories[kieg])
          // context.state.chosenAccessories[kieg].tovabbi_adatok = {}
          Object.keys(valasztottFedezetek[kieg].reszletes)
            .filter((a) => a.includes("_limit"))
            .forEach((adat) => {
              const reszletesAdat = {};
              const key = String(adat).replace(/_limit/g, "");
              reszletesAdat[key] = valasztottFedezetek[kieg].reszletes[adat];
              context.commit("updateAccesory", {
                kod: kieg,
                limit: null,
                tovabbiAdatok: reszletesAdat,
                utasInfok: null,
              });
            });
        }

        if (valasztottFedezetek[kieg].desc) {
          context.commit("setUpDefaultChosenAccessory", {
            kod: kieg,
            key: "biztositottak",
            value: [],
          });
          // console.log(context.state.chosenAccessories[kieg])
          // context.state.chosenAccessories[kieg].biztositottak = []
          const persons = data[
            `${kieg === "utasbiztositas" ? "utas" : "temetes"}_biztositottak`
          ].split(";");
          persons.forEach((person) => {
            const inputs = person.split(",");
            if (inputs.length > 1) {
              const inserted = Object.assign(
                {},
                state.chooseableAccesories.personTemplate,
              );
              inputs.forEach((input) => {
                const split = input.split(":");
                if (split[0] == "nev") inserted.name = split[1];
                if (split[0] == "szuletesi_datum") inserted.bornDate = split[1];
              });
              context.commit("addInsuredPerson", {
                person: inserted,
                listName: kieg,
              });
            }
          });
        }
      });
      // chooseable accesories
      // if (data.ertektargy_osszesen)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'jewelry',
      //     value: parseInt(data.ertektargy_osszesen),
      //   });

      // if (data.ekszerek)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'jewelry',
      //     value: parseInt(data.ekszerek),
      //   });
      // if (data.antik_butorok)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'antiques',
      //     value: parseInt(data.antik_butorok),
      //   });
      // //kepzomuveszeti
      // if (data.kepzomuveszeti)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'fineart',
      //     value: parseInt(data.kepzomuveszeti),
      //   });
      // if (data.szormek)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'exotic',
      //     value: parseInt(data.szormek),
      //   });
      // if (data.gyujtemeny)
      //   context.commit('setValuablesAboveInputs', {
      //     name: 'collection',
      //     value: parseInt(data.gyujtemeny),
      //   });
      // if (data.kiemeltingosag)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'kiemeltingosag', value: true});
      // if (data.ertektargy)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'ertektargy', value: true});
      // if (data.keszpenz)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'keszpenz', value: true});
      // if (data.kulonleges_uveg)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'kulonleges_uveg', value: true});
      // if (data.epites)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'epites', value: true});
      // if (data.assistance)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'assistance', value: true});
      // if (data.fagyasztott_etel_romlas)
      //   context.commit('setChooseableAccesoriesSelected', {
      //     name: 'fagyasztott_etel_romlas',
      //     value: true,
      //   });
      // if (data.szabadban_tarolt)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'szabadban_tarolt', value: true});
      // if (data.kerti_butor)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'kerti_butor', value: true}); // átnevezni, de mire ???
      // if (data.sporteszkoz)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'sporteszkoz', value: true});
      // if (data.kegyeleti)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'kegyeleti', value: true});
      // if (data.kegyeleti_biztositas)
      //   context.commit('setChooseableAccesoriesSelected', {
      //     name: 'kegyeleti_biztositas',
      //     value: true,
      //   });
      // if (data.baleset)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'baleset', value: true});
      // if (data.utasbiztositas)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'utasbiztositas', value: true});
      // if (data.felelosseg)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'felelosseg', value: true});
      // if (data.vizkarextra)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'vizkarextra', value: true});
      // if (data.vandalizmus)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'vandalizmus', value: true});
      // if (data.mezogazdasag)
      //   context.commit('setChooseableAccesoriesSelected', {name: 'mezogazdasag', value: true});
      // if (data.kerti_veszelytelenites)
      //   context.commit('setChooseableAccesoriesSelected', {
      //     name: 'kerti_veszelytelenites',
      //     value: true,
      //   });
      // if (data.zoldenergia)
      //   context.commit('setChooseableAccesoriesSelected', {
      //     name: 'zoldenergia',
      //     value: true,
      //   });

      // if (data.balesetbiztositas_tipusa)
      //   context.commit('setChooseableAccesories', {
      //     name: 'accidentInsuranceType',
      //     value: data.balesetbiztositas_tipusa,
      //   });

      // if (data.kiemeltingosag_osszeg)
      //   context.commit('setChooseableAccesories', {
      //     name: 'priorityProperty',
      //     value: data.kiemeltingosag_osszeg,
      //   });
      // if (data.kiemeltingosag_osszeg)
      //   context.commit('setChooseableAccesories', {
      //     name: 'priorityProperty',
      //     value: data.kiemeltingosag_osszeg,
      //   });
      // if (data.berloi_felelosseg)
      //   context.commit('setChooseableAccesories', {
      //     name: 'landlordLiability',
      //     value: true,
      //   });
      // //mezogazdasagi
      // if (data.termes_termeny)
      //   context.commit('setChooseableAccesories', {
      //     name: 'farmingStock',
      //     value: parseInt(data.termes_termeny),
      //   });
      // if (data.allatallomany)
      //   context.commit('setChooseableAccesories', {
      //     name: 'farmingAnimals',
      //     value: parseInt(data.allatallomany),
      //   });
      // if (data.gepek_felszereles)
      //   context.commit('setChooseableAccesories', {
      //     name: 'farmingTools',
      //     value: parseInt(data.gepek_felszereles),
      //   });
      // if (data.kegyeleti_tipusa)
      //   context.commit('setChooseableAccesories', {
      //     name: 'funeralPrice',
      //     value: parseInt(data.kegyeleti_tipusa),
      //   });

      // insured persons utas
      // if (data.utas_biztositottak) {
      //   const persons = data.utas_biztositottak.split(';');
      //   persons.forEach((person) => {
      //     const inputs = person.split(',');
      //     if (inputs.length > 1) {
      //       const inserted = Object.assign({}, state.chooseableAccesories.personTemplate);
      //       inputs.forEach((input) => {
      //         const split = input.split(':');
      //         if (split[0] == 'nev') inserted.name = split[1];
      //         if (split[0] == 'szuletesi_datum') inserted.bornDate = split[1];
      //       });
      //       context.commit('addInsuredPerson', {person: inserted, listName: 'travelInsuranced'});
      //     }
      //   });
      // }
      // // insured persons kegyeleti
      // if (data.temetes_biztositottak) {
      //   const persons = data.temetes_biztositottak.split(';');
      //   persons.forEach((person) => {
      //     const inputs = person.split(',');
      //     if (inputs.length > 1) {
      //       const inserted = Object.assign({}, state.chooseableAccesories.personTemplate);
      //       inputs.forEach((input) => {
      //         const split = input.split(':');
      //         if (split[0] == 'nev') inserted.name = split[1];
      //         if (split[0] == 'szuletesi_datum') inserted.bornDate = split[1];
      //       });
      //       context.commit('addInsuredPerson', {person: inserted, listName: 'burialInsuranced'});
      //     }
      //   });
      // }

      // payment data
      if (data.dijfizetes_mod)
        context.commit("setPaymentOptions", {
          name: "type",
          value: data.dijfizetes_mod,
        });
      if (data.dijfizetes_gyakorisag)
        context.commit("setPaymentOptions", {
          name: "frequency",
          value: data.dijfizetes_gyakorisag,
        });
      if ("ekommunikacio" in data)
        context.commit("setElectronicContact", parseInt(data.ekommunikacio));
      if ("ekarrendezes" in data)
        context.commit("setElectronicInsuring", parseInt(data.ekarrendezes));
      if ("eletkorkedvezmeny" in data)
        context.commit("setAgeDiscount", parseInt(data.eletkorkedvezmeny));
      if (data.kotes_oka) context.commit("setContraceReason", data.kotes_oka);
      if (data.regi_kotvenyszam)
        context.commit("setOldBondnumber", data.regi_kotvenyszam);
      // 4th page data
      // if (data.kockazat_kezdete)
      //   context.commit('updateRiskSettings', {
      //     name: 'startDate',
      //     value: new Date(data.kockazat_kezdete) || data.kockazat_kezdete,
      //   });
      if (data.kockazat_kezdete)
        context.commit("updateRiskSettings", {
          name: "startDate",
          value: data.kockazat_kezdete,
        });
      if (data.kozterulet)
        context.commit("updateRiskSettings", {
          name: "locationName",
          value: data.kozterulet,
        });
      if (data.kozterulet_jellege)
        context.commit("updateRiskSettings", {
          name: "locationType",
          value: data.kozterulet_jellege,
        });
      if (data.hazszam)
        context.commit("updateRiskSettings", {
          name: "locationHouseNumber",
          value: data.hazszam,
        });
      if (data.kockazat_epl)
        context.commit("updateRiskSettings", {
          name: "locationBuilding",
          value: data.kockazat_epl,
        });
      if (data.kockazat_helyrajzi_szam)
        context.commit("updateRiskSettings", {
          name: "locationTopography",
          value: data.kockazat_helyrajzi_szam,
        });

      if (data.szerzodo_vezeteknev)
        context.commit("updateContractSettings", {
          name: "lastName",
          value: data.szerzodo_vezeteknev,
        });
      if (data.szerzodo_keresztnev)
        context.commit("updateContractSettings", {
          name: "firstName",
          value: data.szerzodo_keresztnev,
        });
      if (data.szerzodo_anyja_leanykori_nev)
        context.commit("updateContractSettings", {
          name: "motherChildName",
          value: data.szerzodo_anyja_leanykori_nev,
        });
      if (data.szerzodo_szuletes_nev)
        context.commit("updateContractSettings", {
          name: "bornName",
          value: data.szerzodo_szuletes_nev,
        });
      if (data.szerzodo_szuletesi_hely)
        context.commit("updateContractSettings", {
          name: "bornCity",
          value: data.szerzodo_szuletesi_hely,
        });
      if (data.szerzodo_szuletesi_datum)
        context.commit("updateContractSettings", {
          name: "bornDate",
          value: data.szerzodo_szuletesi_datum,
        });
      if (data.szerzodo_bankszamlaszam)
        context.commit("updateContractSettings", {
          name: "bankAccountNumber",
          value: data.szerzodo_bankszamlaszam,
        });
      if (data.szerzodo_bankneve)
        context.commit("updateContractSettings", {
          name: "bankName",
          value: data.szerzodo_bankneve,
        });
      if (data.szerzodo_szamlatulajdonosneve)
        context.commit("updateContractSettings", {
          name: "bankAccountHolderName",
          value: data.szerzodo_szamlatulajdonosneve,
        });
      //Ezt nem töltjük vissza, hogy ne menjen az email a link után, és ne engedje tovább úgy hogy nincs érvényes kód
      if (data.szerzodo_email)
        context.commit("updateContractSettings", {
          name: "email",
          value: data.szerzodo_email,
        });
      // if (data.szerzodo_email_2)
      //   context.commit('updateContractSettings', {
      //     name: 'emailVerification',
      //     value: data.szerzodo_email_2,
      //   });
      if (data.szerzodo_telefonszam_korzet)
        context.commit("updateContractSettings", {
          name: "phoneNumberArea",
          value: data.szerzodo_telefonszam_korzet,
        });
      if (data.szerzodo_telefonszam)
        context.commit("updateContractSettings", {
          name: "phoneNumber",
          value: data.szerzodo_telefonszam,
        });

      if (data.szerzodo_levelezes_egyezik)
        context.commit("updateContractSettings", {
          name: "postAddressIsTheSame",
          value: parseInt(data.szerzodo_levelezes_egyezik),
        });

      if (data.szerzodo_levelezes_irsz)
        context.commit("updateContractPostSettings", {
          name: "locationZip",
          value: data.szerzodo_levelezes_irsz,
        });
      if (data.szerzodo_levelezes_telepules)
        context.commit("updateContractPostSettings", {
          name: "locationCity",
          value: data.szerzodo_levelezes_telepules,
        });
      if (data.szerzodo_levelezes_kozterulet)
        context.commit("updateContractPostSettings", {
          name: "locationName",
          value: data.szerzodo_levelezes_kozterulet,
        });
      if (data.szerzodo_levelezes_jelleg)
        context.commit("updateContractPostSettings", {
          name: "locationType",
          value: data.szerzodo_levelezes_jelleg,
        });
      if (data.szerzodo_levelezes_hazszam)
        context.commit("updateContractPostSettings", {
          name: "locationHouseNumber",
          value: data.szerzodo_levelezes_hazszam,
        });
      if (data.szerzodo_levelezes_epl)
        context.commit("updateContractPostSettings", {
          name: "locationBuilding",
          value: data.szerzodo_levelezes_epl,
        });

      if (data.szerzodo_biztositott)
        context.commit("updateInsuredSettings", {
          name: "contractedIsInsured",
          value: parseInt(data.szerzodo_biztositott),
        });
      if (data.biztositott_vezeteknev)
        context.commit("updateInsuredSettings", {
          name: "lastName",
          value: data.biztositott_vezeteknev,
        });
      if (data.biztositott_keresztnev)
        context.commit("updateInsuredSettings", {
          name: "firstName",
          value: data.biztositott_keresztnev,
        });
      if (data.biztositott_anyja_leanykori_nev)
        context.commit("updateInsuredSettings", {
          name: "motherChildName",
          value: data.biztositott_anyja_leanykori_nev,
        });
      if (data.biztositott_szuletes_nev)
        context.commit("updateInsuredSettings", {
          name: "bornName",
          value: data.biztositott_szuletes_nev,
        });
      if (data.biztositott_szuletesi_hely)
        context.commit("updateInsuredSettings", {
          name: "bornCity",
          value: data.biztositott_szuletesi_hely,
        });
      if (data.biztositott_szuletett)
        context.commit("updateInsuredSettings", {
          name: "bornDate",
          value: data.biztositott_szuletett,
        });
      if (data.biztositott_telefonszam_korzet)
        context.commit("updateInsuredSettings", {
          name: "phoneNumberArea",
          value: data.biztositott_telefonszam_korzet,
        });
      if (data.biztositott_telefonszam)
        context.commit("updateInsuredSettings", {
          name: "phoneNumber",
          value: data.biztositott_telefonszam,
        });
      if (data.biztositott_email)
        context.commit("updateInsuredSettings", {
          name: "email",
          value: data.biztositott_email,
        });

      // jelzálog
      if (data.ingatlan_jelzalog)
        context.commit("updateMortgageSettings", {
          name: "propertyIsMortgaged",
          value: parseInt(data.ingatlan_jelzalog),
        });
      if (data.jelzalog_hitelezo_azon)
        context.commit("updateMortgageSettings", {
          name: "mortgageBank",
          value: data.jelzalog_hitelezo_azon,
        });
      if (data.jelzalog_hitelezo_nev)
        context.commit("updateMortgageSettings", {
          name: "creditor",
          value: data.jelzalog_hitelezo_nev,
        });
      if (data.jelzalog_hitelezo_szekhely)
        context.commit("updateMortgageSettings", {
          name: "creditorLocation",
          value: data.jelzalog_hitelezo_szekhely,
        });
      if (data.jelzalog_azonosito)
        context.commit("updateMortgageSettings", {
          name: "mortgageId",
          value: data.jelzalog_azonosito,
        });
      if (data.jelzalog_hitel_tipusa)
        context.commit("updateMortgageSettings", {
          name: "mortgageType",
          value: data.jelzalog_hitel_tipusa,
        });
      if (data.jelzalog_hitel_osszeg)
        context.commit("updateMortgageSettings", {
          name: "mortgagePrice",
          value: parseInt(data.jelzalog_hitel_osszeg),
        });
      if (data.jelzalog_hitel_deviza)
        context.commit("updateMortgageSettings", {
          name: "mortgageCurrency",
          value: data.jelzalog_hitel_deviza,
        });
      if (data.jelzalog_hitel_ujaepites_ertek) {
        context.commit("updateMortgageSettings", {
          name: "rebuildValue",
          value: parseInt(data.jelzalog_hitel_ujaepites_ertek),
        });
      }

      //JAVÍTANI
      if (data.jelzalog_hitel_kezdete)
        context.commit("updateMortgageSettings", {
          name: "mortgageStartDate",
          value: data.jelzalog_hitel_kezdete,
        });
      if (data.jelzalog_hitel_lejarat)
        context.commit("updateMortgageSettings", {
          name: "mortgageEndDate",
          value: data.jelzalog_hitel_lejarat,
        });

      if (data.jelzalog_egyeb_orig) {
        const jelzalog_egyeb = data.jelzalog_egyeb_orig;
        if (typeof jelzalog_egyeb === "string") {
          const mortgages = jelzalog_egyeb.split(";");
          mortgages.forEach((mortgage) => {
            const inputs = mortgage.split(",");
            if (inputs.length > 1) {
              const inserted = Object.assign(
                {},
                state.chooseableAccesories.mortgage.template,
              );
              inputs.forEach((input) => {
                const split = input.split(":");
                if (split[0] == "hitelezo_azon")
                  inserted.mortgageBank = split[1];
                if (split[0] == "hitelezo_neve") inserted.creditor = split[1];
                if (split[0] == "hitelezo_cime")
                  inserted.creditorLocation =
                    split[1] === "-" ? null : split[1];
                if (split[0] == "hitel_azonosito")
                  inserted.mortgageId = split[1];
                if (split[0] == "hitel_tipusa")
                  inserted.mortgageType = split[1];
                if (split[0] == "hitel_osszege")
                  inserted.mortgagePrice = parseInt(split[1]);
                if (split[0] == "hitel_penznem")
                  inserted.mortgageCurrency = split[1];
                if (split[0] == "hitel_kezdete")
                  inserted.mortgageStartDate =
                    split[1] === "-" ? null : split[1];
                if (split[0] == "hitel_lejarat")
                  inserted.mortgageEndDate = split[1] === "-" ? null : split[1];
              });
              context.commit("addMortgage", {
                listName: "mortgage",
                person: inserted,
              });
            }
          });
        }
      }

      if (data.kotes_oka) context.commit("setContraceReason", data.kotes_oka);
      if (data.regi_kotvenyszam)
        context.commit("setOldBondnumber", data.regi_kotvenyszam);
      // statements
      if (data.nyilatkozatok) {
        const nyilatkozatok = data.nyilatkozatok;
        if (nyilatkozatok.includes("adatvedelmi_nyilatkozat"))
          context.commit("updateStatements", {
            name: "privacyStatement",
            value: true,
          });
        if (nyilatkozatok.includes("atkonyveles_nyilatkozat"))
          context.commit("updateStatements", {
            name: "contrctReasonStatement",
            value: true,
          });
        if (nyilatkozatok.includes("biztositasi_feltetelek"))
          context.commit("updateStatements", {
            name: "insuranceTerms",
            value: true,
          });
        if (nyilatkozatok.includes("hirlevel"))
          context.commit("updateStatements", {
            name: "marketingMails",
            value: true,
          });
      }

      setTimeout(() => {
        context.dispatch("getPremium");
        context.commit("setMFOLoadedStatus", true);
      }, 1000);
    },

    updateMarks(context, marks) {
      if (!marks) {
        marks = context.state.marks;
      }

      const validUrl = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i",
      );

      for (let [key, value] of Object.entries(marks)) {
        if (validUrl.test(value)) {
          //this.$http.get(value).then(response => {
          //this.html = response.data;
          //if(response.data) value = response.data
          //});
          //axios.get(value).then(res => {
          //if(res.data) value = res.data
          //})
        }
        if (
          key === "mellek_alapterulet" ||
          key === "mellek_falazat" ||
          key === "mellek_tetozet" ||
          key === "kedvezmenyes_evesdij"
        ) {
          const elements = document.querySelectorAll(`[data-tooltip="${key}"]`);
          elements.forEach((element) => {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                closeButtonAriaLabel: "× Ablak bezárása",
                customClass: {
                  content: "text-align-left",
                },
              });
            });
          });
        } else if (key === "csillag") {
          document.getElementById("invalid_inputs").innerHTML = value;
        } else {
          const element = document.getElementById(`${key}-tooltip`);
          if (element) {
            element.addEventListener("click", () => {
              Swal.fire({
                icon: "question",
                html: value,
                showCloseButton: true,
                showConfirmButton: false,
                closeButtonAriaLabel: "× Ablak bezárása",
                customClass: {
                  content: "text-align-left",
                },
              });
            });
          }
        }
      }
    },
    navigateToSaveUrl(context, fetch_uid) {
      let currentLocation = window.location;
      if (currentLocation.search) {
        // window.location.href =
        //   currentLocation.origin + '/' + currentLocation.search + '&fetch_uid=' + fetch_uid;
        window.location.href = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
      } else {
        window.location.href =
          currentLocation.origin + "/?fetch_uid=" + fetch_uid;
      }
    },
    createFetchURL(context, fetch_uid) {
      let currentLocation = window.location;
      let fetchUrl = "";
      if (currentLocation.search) {
        fetchUrl = replaceUrlParam(
          currentLocation.href,
          "fetch_uid",
          fetch_uid,
        );
      } else {
        fetchUrl = currentLocation.origin + "/?fetch_uid=" + fetch_uid;
      }
      context.commit("setFetchUrl", fetchUrl);
    },
    getSavedDataByUid(context, fetch_uid) {
      context.commit("setFetchUid", fetch_uid);
      context.commit("setNextPageStatus", false);
      const params = new URLSearchParams();
      params.append("fetch_sr", fetch_uid);
      //params.append('marks', 1);

      //console.log(`MFO lekérés – ${mfo_uid}`)
      axios
        .get(
          `${window.eqform.baseURL}/eqformexecutor/fetch_sr/${window.eqform.formID}/${fetch_uid}`,
          {
            headers: {
              Accept: "*/*",
              //'access-control-allow-origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.statusText == "OK") {
            const data = res.data.result.message;
            const filteredData = removeUnusedPropertyFromSaveData(
              data,
              saveDataDefaultValues,
            );
            context.dispatch("loadStateFromData", filteredData);
            context.commit("setNextPageStatus", true);
            context.commit("setGenerateLink", 0);
            // const ZipData = context.cities[context.generalInfo.propertyZip];
            // let cityNames =
            //   typeof zipData.telepules === 'string'
            //     ? [zipData.telepules]
            //     : Object.values(zipData.telepules);
            // let cityName = '';
            // if (this.cityNames.length === 1) {
            //   cityName = this.cityNames[0];
            // }
            // context.commit('setCityName', cityName);
          }
        })
        .catch((error) => {
          console.error("Édes Otthon kommunikációs hiba.");
          // console.log('Error', error.message);
          //Vue.$toast.error('Kommunikációs hiba.')
          //context.commit('setGenerateLink', 0);
          context.commit("setGenerateLink", 0);
        });
    },
    getMFOData(context, mfo_uid) {
      context.commit("setNextPageStatus", false);

      const params = new URLSearchParams();
      params.append("mfo_uid", mfo_uid);
      //console.log(`MFO lekérés – ${mfo_uid}`)

      return axios
        .get("https://coltest.nopa.hu/eqform/mnb/mfo/get/" + mfo_uid, {
          headers: {
            Accept: "*/*",
          },
        })
        .then((res) => {
          const data = res.data?.inputData;
          data.mfo_uid = mfo_uid;

          // if (data) {
          //   context.dispatch('loadStateFromData', data);

          //   context.commit('setNextPageStatus', true);
          // }
        })
        .catch(() => {
          console.error("MFO kommunikációs hiba.");
          //Vue.$toast.error('Kommunikációs hiba.')
        });
    },
    async getSelectLists(context) {
      const apiUrl = `${window.eqform.baseURL}/eqformexecutor/${window.eqform.formID}`;
      const params = new URLSearchParams();

      params.append("kod", "listofcities");

      const cityData = await axios.post(apiUrl, params);
      const cities = cityData?.data?.data?.listofcities ?? [];

      await context.commit("setCities", cities);
    },
    updateChosenAccessory(context, { kod, limit, tovabbiAdatok, utasInfok }) {
      context.commit("updateAccesory", {
        kod,
        limit,
        tovabbiAdatok,
        utasInfok,
      });
    },
    setChosenAccessories(context, kod) {
      if (context.state.chosenAccessories[kod].selected) {
        context.commit("setDefaultAccessory", kod);
      }
      context.commit("setAccessory", kod);
    },
  },
});
